// @flow
import {
	Component,
	OnInit,
	ViewChild,
	ElementRef,
	OnDestroy,
	HostListener, 
	NgZone
} from '@angular/core';
import {
	HttpClient
} from '@angular/common/http';
import {
	Subscription
} from 'rxjs';
import Swal from 'sweetalert2';
import * as $ from 'jquery';
import {
	Router,
	ActivatedRoute
} from '@angular/router';
import {
	HotkeysService,
	Hotkey
} from 'angular2-hotkeys';
import {
	NgbDateStruct,
	NgbCalendar,
	NgbDateParserFormatter,
	NgbModal,
	NgbModalRef,
	NgbModalConfig,
	NgbDate
} from '@ng-bootstrap/ng-bootstrap';

import {
	BsDatepickerConfig
} from 'ngx-bootstrap/datepicker';
var moment = require('moment');
import {
	DatePipe,
	formatDate
} from '@angular/common';
import {
	date
} from 'ngx-custom-validators/src/app/date/validator';
import Drift from 'drift-zoom';
import * as XLSX from 'xlsx';
import bb from 'billboard.js';
import {
	UtilityService
} from '../shared/services/Utility.service';
import {
	HttpHeaders
} from '@angular/common/http';
import {
	ColumnApi,
	GridApi,
	GridOptions
} from 'ag-grid-community'

const axios = require('axios');

import { EChartOption } from 'echarts';
import { concat } from 'lodash';

@Component({
	selector: 'ordertrackerdashboard',
	template: require('./OrderTrackerDashboard.html'),
	styles: [`
    .bs-datepicker{
      top: 150px !important;
    }
    `],
})

export class OrderTrackerDashboardComponent implements OnInit, OnDestroy {

	static parameters = [HttpClient, HotkeysService, Router, NgbModal, UtilityService, BsDatepickerConfig,NgZone ];
	@ViewChild('CycleConfig') CycleConfig: ElementRef;
	@ViewChild('RatioDetails') RatioDetails: ElementRef;
	@ViewChild('CPTDetails') CPTDetails: ElementRef;
	@ViewChild('DOHStock') DOHStock: ElementRef;
	cycleConfigReference: NgbModalRef;
	StockRatioReference: NgbModalRef;
	CPTDetailsReference: NgbModalRef;
	DOHStockReference: NgbModalRef;
	busy: Subscription;
	loading: boolean = true;
	dateFormat: any;
	bsConfig: BsDatepickerConfig;
	unitInfo: any;
	createdBy: any;
	selecteDate: any;
	selecteFromDate: any;
	selecteToDate: any;
	lotdetail: any = [];
	diffTime: any = 0;
	public navigateToNextCell: any;
	public defaultColDefine;
	private rowSelection: any;
	RefreshTime: any = 0;
	DefaultRefreshTime: any = 5;
	tiles: any = [];
	public hotkeyList: Hotkey[];
	public hotkeyListModal: Hotkey[];
	activeGraph: any = 1;
	dashboarsettings: any = {};
  Invoice_Filter_Type:any;
  CPT_Filter_Type:any;
  DashnosrdType:any;
  DashnosrdTypeList:any = [];

	constructor(private http: HttpClient, private hotkeysService: HotkeysService, private router: Router,  private modalService: NgbModal,  private UtilityService: UtilityService, public _bsDatepickerConfig: BsDatepickerConfig, public ngZone: NgZone) {
		this.http = http;
		this.router = router;
		this.hotkeysService = hotkeysService;
		this.modalService = modalService;
		// this.datePipe = datePipe;
		this.ngZone = ngZone;
		console.log('🚀 ~ this.ngZone:', this.ngZone);
		this.dateFormat = JSON.parse(localStorage.getItem('permission'))[0];
		this.bsConfig = Object.assign(new BsDatepickerConfig(), {
			dateInputFormat: 'DD-MMM-YYYY',
			containerClass: this.dateFormat.dateColorTheme
		});
		this._bsDatepickerConfig.dateInputFormat = 'DD-MMM-YYYY';

		this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
		this.createdBy = this.unitInfo._id;
		this.defaultColDefine = {
			resizable: true,
			sortable: true,
			suppressDragLeaveHidesColumns: true,
			cellStyle: function(params) {
				if (isNaN(params.value)) {
					return {
						textAlign: 'left'
					};
				} else {
					return {
						textAlign: 'right'
					};
				}
			},
		};
	}


	ngOnInit(): void {
	this.LoginED();
    this.DashnosrdTypeList = [
      {"DashType": "Order", "DashDiscription": "Order"},
      {"DashType": "CPT", "DashDiscription": "CPT"}
    ]

    this.DashnosrdType = "CPT";
		this.tiles = [];
		this.tiles.loading = true;
    this.dashboarsettings = {};
		// this.RefreshTime = 5;
		// this.dashboarsettings.RefreshTime = 5;
		this.selecteDate = new Date();
		// this.selecteFromDate = new Date();
		let newdate1 = new Date();
		this.selecteToDate = new Date();
		newdate1.setDate(this.selecteToDate.getDate() - 1);
		this.selecteFromDate = newdate1;
		this.onRefresh();
		// this.GetOrderTrackerDashboardData();
		this.rowSelection = "single";
		
		this.GetSmtpLoginDetailsOrder_Tracker_Dashboard_Mail();
    this.initHotkeys();

		// this.GetWarehouseDashboardDetail();
		// this.startAutoCycle();
		/*     try {
		      // console.table(this.tileAutoCycleConfig);
		      if ("SystemConfigDetails" in localStorage) {
		        var data = JSON.parse(localStorage.getItem('SystemConfigDetails'))
		  
		        let totalBills = data.filter(function (item) {
		          return item.Config_Name === 'WAREHOUSE DASHBOARD FLASH TIME FOR TOTAL BILLS(BILL WISE)'
		        });
		        let totalBillsvalue = this.f_chknum(totalBills.length > 0 ? totalBills[0].Config_Value : 0);
		        this.tileAutoCycleConfig.find(t => t.warehouseId === 1).billWiseInterval = totalBillsvalue;
		        
		        let totalroute = data.filter(function (item) {
		          return item.Config_Name === 'WAREHOUSE DASHBOARD FLASH TIME FOR TOTAL BILLS(ROUTE WISE)'
		        });
		        let totalroutevalue = this.f_chknum(totalroute.length > 0 ? totalroute[0].Config_Value : 0);
		        this.tileAutoCycleConfig.find(t => t.warehouseId === 1).routeWiseInterval = totalroutevalue;
		  
		        let pendingtoAsign = data.filter(function (item) {
		          return item.Config_Name === 'WAREHOUSE DASHBOARD FLASH TIME FOR PENDING TO ASSIGN'
		        });
		        let pendingtoAsignvalue = this.f_chknum(pendingtoAsign.length > 0 ? pendingtoAsign[0].Config_Value : 0);
		        this.tileAutoCycleConfig.find(t => t.warehouseId === 2).interval = pendingtoAsignvalue;
		        
		        let picking = data.filter(function (item) {
		          return item.Config_Name === 'WAREHOUSE DASHBOARD FLASH TIME FOR PICKING'
		        });
		        let pickingvalue = this.f_chknum(picking.length > 0 ? picking[0].Config_Value : 0);
		        this.tileAutoCycleConfig.find(t => t.warehouseId === 3).interval = pickingvalue;
		  
		        let checking = data.filter(function (item) {
		          return item.Config_Name === 'WAREHOUSE DASHBOARD FLASH TIME FOR CHECKING'
		        });
		        let checkingvalue = this.f_chknum(checking.length > 0 ? checking[0].Config_Value : 0);
		        this.tileAutoCycleConfig.find(t => t.warehouseId === 4).interval = checkingvalue;
		  
		        let dispatchRW = data.filter(function (item) {
		          return item.Config_Name === 'WAREHOUSE DASHBOARD FLASH TIME FOR DISPATCH(ROUTE WISE)'
		        });
		        let dispatchRWvalue = this.f_chknum(dispatchRW.length > 0 ? dispatchRW[0].Config_Value : 0);
		        this.tileAutoCycleConfig.find(t => t.warehouseId === 5).dispatchRouteInterval = dispatchRWvalue;
		        
		        let dispatchSW = data.filter(function (item) {
		          return item.Config_Name === 'WAREHOUSE DASHBOARD FLASH TIME FOR DISPATCH(SALESMAN WISE)'
		        });
		        let dispatchSWvalue = this.f_chknum(dispatchSW.length > 0 ? dispatchSW[0].Config_Value : 0);
		        this.tileAutoCycleConfig.find(t => t.warehouseId === 5).dispatchSalesmanInterval = dispatchSWvalue;
		        

		        let rowload = data.filter(function (item) {
		          return item.Config_Name === 'WAREHOUSE DASHBOARD FLASH TIME FOR ROW LOAD'
		        });
		  
		        let rowloadvalue = this.f_chknum(rowload.length > 0 ? rowload[0].Config_Value : 0);
		        this.tileAutoCycleConfig.find(t => t.warehouseId === 6).interval = rowloadvalue;
		    
		        // console.table(this.tileAutoCycleConfig);

		      }
		    } catch (error) {
		      console.log('🚀 ~ error while setting permission values:', error);
		    } */
	}

	initHotkeys() {
		this.hotkeyList = [];
		this.hotkeyListModal = [];
		/* const ctrlf = new Hotkey('ctrl+f', (event: KeyboardEvent): boolean => {
		    var textbox: any;
		    textbox = document.querySelector('#filter-text-box');
		    if (textbox) {
		        const bound = textbox.getBoundingClientRect();
		        if (bound && bound.top) {
		            $('#filter-text-box').focus();
		        }
		    }
		    textbox = document.querySelector('#prodfilter-text-box');
		    if (textbox) {
		        const bound = textbox.getBoundingClientRect();
		        if (bound && bound.top) {
		            $('#prodfilter-text-box').focus();
		        }
		    }
		    textbox = document.querySelector('#Serach_Text_Box');
		    if (textbox) {
		        const bound = textbox.getBoundingClientRect();
		        if (bound && bound.top) {
		            $('#Serach_Text_Box').focus();
		        }
		    }
		    textbox = document.querySelector('#common_Serach_Text_Box');
		    if (textbox) {
		        const bound = textbox.getBoundingClientRect();
		        if (bound && bound.top) {
		            $('#common_Serach_Text_Box').focus();
		        }
		    }
		    textbox = document.querySelector('#PromoItemSearchBox');
		    if (textbox) {
		        const bound = textbox.getBoundingClientRect();
		        if (bound && bound.top) {
		            $('#PromoItemSearchBox').focus();
		        }
		    }
		    textbox = document.querySelector('#Serach_Text_Box1');
		    if (textbox) {
		        const bound = textbox.getBoundingClientRect();
		        if (bound && bound.top) {
		            $('#Serach_Text_Box1').focus();
		        }
		    }
		    textbox = document.querySelector('#cust-ledger-filter-text-box');
		    if (textbox) {
		        const bound = textbox.getBoundingClientRect();
		        if (bound && bound.top) {
		            $('#cust-ledger-filter-text-box').focus();
		        }
		    }

		    textbox = document.querySelector('#IGNSerach_Text_Box');
		    if (textbox) {
		        const bound = textbox.getBoundingClientRect();
		        if (bound && bound.top) {
		            $('#IGNSerach_Text_Box').focus();
		        }
		    }
		    textbox = document.querySelector('#search_AT');
		    if (textbox) {
		        const bound = textbox.getBoundingClientRect();
		        if (bound && bound.top) {
		            $('#search_AT').focus();
		        }
		    }
		    textbox = document.querySelector('#Search_Text_Box');
		    if (textbox) {
		        const bound = textbox.getBoundingClientRect();
		        if (bound && bound.top) {
		            $('#Search_Text_Box').focus();
		        }
		    }
		    return false;
		}, ['INPUT', 'SELECT', 'TEXTAREA']);
		this.hotkeyList.push(ctrlf);
		this.hotkeysService.add(ctrlf); */

		/* const ctrlf = new Hotkey('ctrl+f', (event: KeyboardEvent): boolean => {

			$("input[name=search_AT]").focus();

			return false;
		}, ['INPUT', 'SELECT', 'TEXTAREA']);
		this.hotkeyList.push(ctrlf);
		this.hotkeysService.add(ctrlf); */
	}
	ngOnDestroy(): void {
    clearTimeout(this.RefTimeOut);
		// Clear any active timer to prevent memory leaks
		console.log('ngDestroy called :this.autoCycleTimer:: ', this.autoCycleTimer);
		if (this.autoCycleTimer) {
			clearTimeout(this.autoCycleTimer);
			console.log('🚀 ~ this.autoCycleTimer:', this.autoCycleTimer)

			this.autoCycleTimer = null;
		}
		console.log('🚀 ~ this.autoCycleTimer:', this.autoCycleTimer)
		clearInterval(this.intervalId);
		if (this.CPTChartInstance) {
			this.CPTChartInstance.dispose();
		}
	}

	activeWarehouse: number = 0;
	ActiveLable: any = '';
	ActiveLableCount: any = 0;
	GetDataType: any = '';
	setactiveWarehouse(buttonNumber: number): void {
		// 1. Cancel existing auto-cycle timer
		// if (this.autoCycleTimer) {
		//   clearTimeout(this.autoCycleTimer);
		//   this.autoCycleTimer = null;
		// }
		// if (this.activeWarehouse !== buttonNumber ) {
		if (this.activeWarehouse == buttonNumber) {
			this.activeWarehouse = 0;
			this.GetDataType = '';
			this.ActiveLable = '';
			this.Get_Order_Tracker_Dashboard_Stats_OrderVsSales();
			this.Get_Order_Tracker_Dashboard_Stats_ShortExcessStockRatio();
		} else {
			this.activeWarehouse = buttonNumber;


			this.activeWarehouse = buttonNumber;
			if (buttonNumber === 1) {
				this.ActiveLable = 'Orders';
				this.GetDataType = 'Orders';
				this.ActiveLableCount = this.TotalOrderCount;
			} else if (buttonNumber === 2) {
				this.ActiveLable = 'Invoice / Cancelled';
				this.GetDataType = 'Invoice';
				this.ActiveLableCount = concat(this.TotalInvoiceCount  + '/' + this.TotalCancelInvoiceCount);
			} else if (buttonNumber === 3) {
				this.ActiveLable = 'Sync Invoice / Pending';
				this.GetDataType = '';
				this.ActiveLableCount = concat(this.synccount + '/' + this.pendingsynccount);
			} else if (buttonNumber === 4) {
				this.ActiveLable = 'Pending Order';
				this.GetDataType = 'Pending';
				this.ActiveLableCount = this.TotalPendingOrderCount;
			} else if (buttonNumber === 5) {
				this.ActiveLable = 'Failed Order';
				this.GetDataType = 'Failed';
				this.ActiveLableCount = this.TotalFailedOrderCount;
			} else if (buttonNumber === 6) {
				this.ActiveLable = 'Not Pick';
				this.GetDataType = 'NotPick';
				this.ActiveLableCount = this.TotalNotPickedCount;
			}

			console.log("====>", this.ActiveLable);
			console.log("====>", this.ActiveLableCount);
			console.log("====>", this.TotalInvoiceCount);
			console.log("====>", this.TotalCancelInvoiceCount);
			console.log("====>", (this.TotalInvoiceCount, "/" , this.TotalCancelInvoiceCount));
			this.GetOrderTrackerDashboardStatsDetails();
		}
		// }

		// Update autoCycleIndex so startAutoCycle() knows which tile you're on
		// const foundIndex = this.tileAutoCycleConfig.findIndex(
		//   t => t.warehouseId === buttonNumber
		// );
		// this.autoCycleIndex = foundIndex !== -1 ? foundIndex : 0;

		// 4. **Pause auto-cycle when user manually clicks a tile**
		// this.isCycling = false;
	}

	activeCstabs: number = 2;
	setactiveCstabs(buttonNumber: number): void {
		if (this.activeCstabs !== buttonNumber) {
			this.activeCstabs = buttonNumber;
			if (buttonNumber === 1) {
				// this.GetWarehouseDashboardDetail("TB", "RW");
			} else {
				// this.GetWarehouseDashboardDetail("TB", "BW");
			}
		}
	}


	activeDispatchTabs: number = 1;
	setactiveDispatchTabs(buttonNumber: number): void {
		if (this.activeDispatchTabs !== buttonNumber) {
			this.activeDispatchTabs = buttonNumber;
			if (buttonNumber === 1) {
				this.GetWarehouseDashboardDetail("DP", "RW");
			} else {
				this.GetWarehouseDashboardDetail("DP", "SM");
			}
		}
	}

	// isChartInitialized: boolean = false;
	// ngAfterViewChecked(): void {
	//     if (this.activeWarehouse === 1 && ! this.isChartInitialized) {
	//       const barChartElement = document.getElementById('barChart');
	//       if (barChartElement && !barChartElement.hasChildNodes()) {
	//         this.initBarChart();
	//         this.isChartInitialized = false;
	//       }
	//     } 
	//   }

	// ["x", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00"],

	inittotalBills(x, Order, Invoice): void {
		bb.generate({
			data: {
				x: "x",
				columns: [
					["x", ...x],
					["Order", ...Order],
					["Invoice", ...Invoice]
				],
				type: "bar",
				colors: {
					Order: "#6e94b8",
					Invoice: "#FFC700"
				},
				labels: true // Enable bar value labels
			},
			axis: {
				rotated: true,
				y: {
					show: false
				},
				x: {
					type: "timeseries",
					tick: {
						format: "%b-%d"
					}
				}
			},
			legend: {
				show: true
			},
			// bindto: "#totalBills"
		});

		// Set background color
		setTimeout(() => {
			const chartContainer = document.querySelector("#totalBills");
			const svg = chartContainer.querySelector("svg");

			// Add a white background
			const rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
			rect.setAttribute("width", "100%");
			rect.setAttribute("height", "100%");
			rect.setAttribute("fill", "white");
			svg.insertBefore(rect, svg.firstChild);
		}, 100);
	}

	inittotalBillsRatio(formattedData): void {
		/* bb.generate({
		  data: {
		    columns: [
		      ["Mar-5", 98.46],
		      ["Mar-6", 98.38],
		      ["Mar-7", 98.65],
		      ["Mar-8", 98.1],
		      ["Mar-9", 98.15],
		      ["Mar-10", 97.79],
		      ["Mar-11", 98.52],
		      ["Mar-12", 98.7]
		    ],
		    type: "pie"
		  },
		  color: {
		    pattern: [
		      "#ff6384", "#36a2eb", "#ffce56", "#4bc0c0",
		      "#9966ff", "#ff9f40", "#8a89a6", "#98df8a", "#d62728"
		    ]
		  },
		  pie: {
		    label: {
		      show: true,
		      format: (value, ratio, id) => `${value}` // Shows values as percentages
		    }
		  },
		  legend: {
		    show: true,
		    position: 'right'
		  },
		  bindto: "#pendingAssign"
		}); */

		bb.generate({
			data: {
				columns: formattedData,
				type: "pie", // for ESM specify as: pie()
			},

			color: {
				pattern: ["#ff6384", "#36a2eb", "#ffce56", "#4bc0c0", "#9966ff", "#ff9f40", "#8a89a6", "#98df8a", "#d62728"]
			},
			legend: {
				show: true,
				position: 'right'
			},
			// bindto: "#pendingAssign"
		});
	}

	initTopselling(x, ShortRatio, ExcessRatio): void {
		/* bb.generate({
		  data: {
		    x: "x",
		    columns: [
		      ["x", ...x],
		      ["Order", ...Order],
		      ["Invoice", ...Invoice]
		    ],
		    type: "bar",
		    colors: {
		      Order: "#e588ce",
		      Invoice: "#9d8ddd"
		    },
		    labels: true // Enable bar value labels
		  },
		  axis: {
		    rotated: true,
		    y: {
		      show: false
		    },
		    x: {
		      type: "timeseries",
		      tick: {
		        format: "%b-%d"
		      }
		    }
		  },
		  legend: {
		    show: true
		  },
		  bindto: "#totalBills"
		});
		
		// Set background color
		setTimeout(() => {
		  const chartContainer = document.querySelector("#totalBills");
		  const svg = chartContainer.querySelector("svg");
		
		  // Add a white background
		  const rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
		  rect.setAttribute("width", "100%");
		  rect.setAttribute("height", "100%");
		  rect.setAttribute("fill", "white");
		  svg.insertBefore(rect, svg.firstChild);
		}, 100); */
		let self = this;
		bb.generate({
			// bindto: "#ShortExcessStockRatio",
			data: {
				columns: [
					["Short", ...ShortRatio],
					["Excess", ...ExcessRatio]
				],
				type: "bar",
				groups: [
					["Short", "Excess"]
				], // Stack bars
				colors: {
					Short: "#FFA38F",
					Excess: "#86A788"
				},
				// Correct event handler for bar click
				onclick: function(d) {
					console.log("Clicked:", d); // Debugging: Log data to console
					// self.clickStockRatio(x[d.index], d.value, d.id); // Ensure you're fetching the correct category
				}
			},
			axis: {
				x: {
					type: "category",
					categories: x // Ensure 'x' matches the categories length
				}
			},
			bar: {
				width: {
					ratio: 0.6 // Adjust bar width
				}
			}
		});


	}

	initTCPTDATA(x,OrdersCount,InvoiceCount,PendingCount,FailedCount,PickedCount,PendingPicked): void {
	// initTCPTDATA(x, ShortRatio, ExcessRatio): void {
    console.log('XXXXXX:------',x);
		let self = this;
    // let parseDate = d3.timeParse("%Y-%m-%d %H:%M:%S"); // Define the custom date format

    var chart2 = bb.generate({
      data: {
        x: "x",
				columns: [
					// ["x", ...x ],
         ["x", 1,2,3,4,5,6,7,8,9, 10],
          // ["x", ...x.map(d => parseDate(d))],
					["OrdersCount", ...OrdersCount],
					["InvoiceCount", ...InvoiceCount],
					["PendingCount", ...PendingCount],
					["FailedCount", ...FailedCount],
					["PickedCount", ...PickedCount],
					["PendingPicked", ...PendingPicked]
				],
        
        type: 'bar',
        groups: [['OrdersCount', 'InvoiceCount', 'PendingCount','FailedCount','PickedCount','PendingPicked']],
        labels: true,
        stack: {
          normalize: false,
        },
        colors: {
					OrdersCount: "#d8a6a6",
					InvoiceCount: "#54a1a1",
					PendingCount: "#b8b8b8",
					FailedCount: "#3594cc",
					PickedCount: "#5e4c5f",
					PendingPicked: "#1a80bb",
				},
      },
      
      axis: {
        rotated: true,
        // y2: {
        //   show: true,
        // },
        /* x: {
          type: "timeseries",
          tick: {
            format: "%b-%d %H:%M:%S", // Custom date-time format
          },
        }, */
      },
      // tooltip: {
        
      //   position(data: any, width: number, height: number, element: any, pos:any=0) {
      //     const total = data.reduce((a, { value }) => a + value, 0);
      //     console.log("Object:", data); 
      //     console.log("Position Object:", pos); // Debugging output
          
      //     return this.config('axis.rotated')
      //       ? {
      //           top: pos.xAxis - width / 2, // Using pos.x instead of pos.xAxis
      //           left: pos.y, // Using pos.y instead of pos.yAxis(total)
      //         }
      //       : {
      //           top: pos.y - height, // Using pos.y instead of pos.yAxis(total)
      //           left: pos.x - width / 2, // Using pos.x instead of pos.xAxis
      //         };
      //   },
      // },
      tooltip: {
        position(data: any, width: number, height: number, element: any, pos:any=0) {
          if (!pos) return { top: 0, left: 0 }; // Prevent undefined errors
          
          return {
            top: pos.x || 0 - width / 2,
            left: pos.y || 0 - height,
          };
        },
      },
    //   bindto: '#CPTDATA',
    });

    setTimeout(() => {
      const chartContainer = document.querySelector("#CPTDATA");
      if (!chartContainer) return; // Prevent errors if element is missing
    
      const svg = chartContainer.querySelector("svg");
      if (!svg) return; // Ensure SVG exists before modifying
    
      const rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
      rect.setAttribute("width", "100%");
      rect.setAttribute("height", "100%");
      rect.setAttribute("fill", "white");
      svg.insertBefore(rect, svg.firstChild);
    }, 1000);
	}

	initPendingAssign(x, Prev_Pending_To_Assign, Pending_To_Assign): void {
		bb.generate({
			data: {
				x: "x",
				xFormat: "%H:%M", // Define the format of the x-axis data
				columns: [
					// Define the x-axis values as actual time strings
					// ["x", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00"],
					// ["Previous Day", 30, 200, 100, 400, 150, 250, 30, 200, 100, 400, 150, 250, 400],
					// ["Today", 130, 340, 200, 500, 250, 350,130, 340, 200, 500, 250, 350, 500]
					["x", ...x],
					["Prev Pending", ...Prev_Pending_To_Assign],
					["Pending Assign", ...Pending_To_Assign],
					// ["x", "00:01", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"],
					// ["Previous Day", 0, 0, 0, 0, 0, 2, 0, 0, 19, 26, 53, 54, 46, 34, 44, 27, 34, 7, 3, 2, 3, 6, 13, 5],
					// ["Today",        1, 0, 0, 0, 0, 6, 0, 0, 8, 24, 49, 44, 33, 27, 12, 0, 0, 0, 0, 0, 0, 15, 35, 0]


				],
				type: "line", // Specify the chart type
			},
			axis: {
				x: {
					type: "timeseries", // Define the x-axis type as timeseries
					// localtime: true,   // Use UTC or not
					tick: {
						// format: "%H:%M",  // Display the time in hour:minute format
						// fit: true,        // Ensure the ticks fit into the chart
						// multiline: true,
						// rotate: 65,
						centered: true,
						fit: true,
						format: "%H:%M",
					},
				},
			},
			bar: {
				width: {
					ratio: 0.5,
				},
			},
			color: {
				pattern: ["#FF8000", "#C5A467"],
			},
			grid: {
				x: {
					show: true, // Enable vertical gridlines
				},
			},
			size: {
				height: 160, // Set chart height
			},
			// bindto: "#pendingAssign",
		});
	}


	initPicKing(x, Prev_Picking, Today_Picking): void {
		bb.generate({
			data: {
				x: "x",
				xFormat: "%H:%M", // Define the format of the x-axis data
				columns: [
					// Define the x-axis values as actual time strings
					// ["x", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00"],
					// ["Previous Day", 30, 200, 100, 400, 150, 250, 30, 200, 100, 400, 150, 250, 400],
					// ["Today", 130, 340, 200, 500, 250, 350,130, 340, 200, 500, 250, 350, 500]
					["x", ...x],
					["Prev Picked", ...Prev_Picking],
					["Today Picked", ...Today_Picking],
				],
				type: "line", // Specify the chart type
			},
			axis: {
				x: {
					type: "timeseries", // Define the x-axis type as timeseries
					// localtime: true,   // Use UTC or not
					tick: {
						// format: "%H:%M",  // Display the time in hour:minute format
						// fit: true,        // Ensure the ticks fit into the chart
						// multiline: true,
						// rotate: 65,
						centered: true,
						fit: true,
						format: "%H:%M",
					},
				},
			},
			bar: {
				width: {
					ratio: 0.5,
				},
			},
			color: {
				pattern: ["#FF8000", "#A862A6"],
			},
			grid: {
				x: {
					show: true, // Enable vertical gridlines
				},
			},
			size: {
				height: 160, // Set chart height
			},
			// bindto: "#picKing",
		});
	}


	initChecKing(x, Prev_Checked, Today_Checked): void {
		bb.generate({
			data: {
				x: "x",
				xFormat: "%H:%M", // Define the format of the x-axis data
				columns: [
					// Define the x-axis values as actual time strings
					// ["x", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00"],
					// ["Previous Day", 30, 200, 100, 400, 150, 250, 30, 200, 100, 400, 150, 250, 400],
					// ["Today", 130, 340, 200, 500, 250, 350,130, 340, 200, 500, 250, 350, 500]
					["x", ...x],
					["Prev Checked", ...Prev_Checked],
					["Today Checked", ...Today_Checked],
				],
				type: "line", // Specify the chart type
			},
			axis: {
				x: {
					type: "timeseries", // Define the x-axis type as timeseries
					// localtime: true,   // Use UTC or not
					tick: {
						// format: "%H:%M",  // Display the time in hour:minute format
						// fit: true,        // Ensure the ticks fit into the chart
						// multiline: true,
						// rotate: 65,
						centered: true,
						fit: true,
						format: "%H:%M",
					},
				},
			},
			bar: {
				width: {
					ratio: 0.5,
				},
			},
			color: {
				pattern: ["#FF8000", "#A9C56F"],
			},
			grid: {
				x: {
					show: true, // Enable vertical gridlines
				},
			},
			size: {
				height: 160, // Set chart height
			},
			// bindto: "#checKing",
		});
	}


	initDisPatch(x, Prev_Dispatched, Today_Dispatched): void {
		bb.generate({
			data: {
				x: "x",
				xFormat: "%H:%M", // Define the format of the x-axis data
				columns: [
					// Define the x-axis values as actual time strings
					// ["x", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00"],
					// ["Previous Day", 30, 200, 100, 400, 150, 250, 30, 200, 100, 400, 150, 250, 400],
					// ["Today", 130, 340, 200, 500, 250, 350,130, 340, 200, 500, 250, 350, 500]
					["x", ...x],
					["Prev Dispatched", ...Prev_Dispatched],
					["Today Dispatched", ...Today_Dispatched],
				],
				type: "line", // Specify the chart type
			},
			axis: {
				x: {
					type: "timeseries", // Define the x-axis type as timeseries
					// localtime: true,   // Use UTC or not
					tick: {
						// format: "%H:%M",  // Display the time in hour:minute format
						// fit: true,        // Ensure the ticks fit into the chart
						// multiline: true,
						// rotate: 65,
						centered: true,
						fit: true,
						format: "%H:%M",
					},
				},
			},
			bar: {
				width: {
					ratio: 0.5,
				},
			},
			color: {
				pattern: ["#FF8000", "#59A97B"],
			},
			grid: {
				x: {
					show: true, // Enable vertical gridlines
				},
			},
			size: {
				height: 160, // Set chart height
			},
			// bindto: "#disPatch",
		});
	}


	warehouseDashboardSummary: any = {
		"Total_Bills": 0,
		"Pending_To_Assign": 0,
		"Picked": 0,
		"Checked": 0,
		"Dispatched": 0,
		"Row_Load": 0,
		"Picking": 0,
		"Checking": 0,
	};

	getWarehouseDashboardSummary(): void {
		const reqPayload = {
			Unit_ID: this.unitInfo.Unit_ID,
			Company_ID: this.unitInfo.Company_ID,
			Doc_Date: moment(this.selecteDate).format('YYYY-MM-DD'),
		};

		this.busy = this.http.post('api/warehouses/GetWarehouseDashboardSummary', reqPayload)
			.subscribe((response: {
				Total_HeaderCount: any[],
				Total_Bills_Graph: any[],
				Pending_To_Assign_Graph: any[],
				Picking_Graph: any[],
				Checking_Graph: any[],
				Dispached_Graph: any[]
			}) => {
				// console.log(response);
				if (response.Total_HeaderCount.length > 0) {
					this.warehouseDashboardSummary = response.Total_HeaderCount[0];
				}
				if (response.Total_Bills_Graph.length > 0) {
					this.Total_Bills_Graph = response.Total_Bills_Graph;
					// this.initTotalBillsGraph(response.Total_Bills_Graph);
					let x = this.Total_Bills_Graph.map((item) => `${item.THr}:00`);
					let PrevDay_Inv_Count = this.Total_Bills_Graph.map((item) => item.PrevDay_Inv_Count);
					let Today_Inv_Count = this.Total_Bills_Graph.map((item) => item.Today_Inv_Count);
					this.inittotalBills(x, PrevDay_Inv_Count, Today_Inv_Count);
				}
				if (response.Pending_To_Assign_Graph.length > 0) {
					let x = response.Pending_To_Assign_Graph.map((item) => `${item.THr}:00`);
					let Prev_Pending_To_Assign = response.Pending_To_Assign_Graph.map((item) => item.Prev_Pending_To_Assign);
					let Pending_To_Assign = response.Pending_To_Assign_Graph.map((item) => item.Pending_To_Assign);
					this.initPendingAssign(x, Prev_Pending_To_Assign, Pending_To_Assign);
				}
				if (response.Picking_Graph.length > 0) {
					let x = response.Picking_Graph.map((item) => `${item.THr}:00`);
					let Prev_Picking = response.Picking_Graph.map((item) => item.Prev_Picked);
					let Today_Picking = response.Picking_Graph.map((item) => item.Today_Picked);
					this.initPicKing(x, Prev_Picking, Today_Picking);
				}
				if (response.Checking_Graph.length > 0) {
					let x = response.Checking_Graph.map((item) => `${item.THr}:00`);
					let Prev_Checked = response.Checking_Graph.map((item) => item.Prev_Checked);
					let Today_Checked = response.Checking_Graph.map((item) => item.Today_Checked);
					this.initChecKing(x, Prev_Checked, Today_Checked);
				}
				if (response.Dispached_Graph.length > 0) {
					let x = response.Dispached_Graph.map((item) => `${item.THr}:00`);
					let Prev_Dispatched = response.Dispached_Graph.map((item) => item.Prev_Dispatch_Count);
					let Today_Dispatched = response.Dispached_Graph.map((item) => item.Today_Dispatch_Count);
					this.initDisPatch(x, Prev_Dispatched, Today_Dispatched);
				}
			});
	}

	trackByFnRouteWise(index: number, item: any): number {
		return item.Route_Code;
	}

	routewise: any[] = [];
	billwise: any[] = [];
	pendingToAssign: any[] = [];
	picking: any[] = [];
	checking: any[] = [];
	dispached: any[] = [];
	dispachedRW: any[] = [];
	dispachedSM: any[] = [];
	RackLoadData: any[] = [];
	rackloadDetails: any[] = [];
	RackLoadDetailscolumnDefs: any;
	todayPicker: any = {
		"Picker_Name": "",
	};
	todayChecker: any = {
		"Checker_Name": "",
	};
	checkerStatusCount: any = {
		"active": 0,
		"inactive": 0
	};
	pickerStatusCount: any = {
		"active": 0,
		"inactive": 0
	};
	routeStatus: any = {
		delay: 0,
		onTime: 0,
		superDelay: 0
	};
	GetWarehouseDashboardDetail(Type = "TB", SubType = "BW"): void {
		const requestPayload = {
			"Company_ID": this.unitInfo.Company_ID,
			"Unit_ID": this.unitInfo.Unit_ID,
			"Doc_Date": moment(this.selecteDate).format('YYYY-MM-DD'),
			"Type": Type,
			"SubType": SubType
		};
		this.busy = this.http.post('api/warehouses/GetWarehouseDashboardDetail', requestPayload)
			.subscribe((response: any = {
				billwise: [],
				pendingToAssign: [],
				picking: [],
				checking: [],
				dispached: [],
				routewise: [],
				rackload: []
			}) => {
				if (response) {
					this.routewise = response.routewise || [];
					this.routeStatus = this.countPerformanceCategories(this.routewise);
					// console.log("this.countPerformanceCategories(this.routewise)", this.routeStatus);
					this.billwise =
						response.billwise || []
					// [
					//   { Bill_No: "SB-24-124998", Item_Count: "5", APT: "10", AT:"10", DT:"251"  }
					// ];
					this.pendingToAssign = response.pendingToAssign || []

					this.picking = response.picking || [];

					this.todayPicker = this.getPickerOfTheDay(this.picking) || {
						Picker_Name: ""
					};
					this.pickerStatusCount = this.getPickerActiveInactiveCounts(this.picking);
					// console.log('🚀 ~ todayPicker:', this.todayPicker)
					this.checking =
						response.checking || [];

					this.todayChecker = this.getCheckerOfTheDay(this.checking) || {
						Checker_Name: ""
					};
					this.checkerStatusCount = this.getCheckerActiveInactiveCounts(this.checking);
					// console.log('🚀 ~ this.todayChecker:', this.todayChecker)

					this.dispachedRW = response.dispachedRW || []

					this.dispachedSM = response.dispachedSM || [];

					// this.rackLoadData = response.rackload || [];
					if (response.rackload && response.rackload.length > 0) {
						this.RackLoadData = response.rackload;
						try {
							if (this.RackLoadData.length > 0) {
								this.getBinDetails("RL", "DL", this.RackLoadData[0].Bin_Name);
							}
						} catch (error) {
							console.log('🚀 ~ error:', error);
						}
					} else {
						this.RackLoadData = [];
						this.rackloadDetails = [];
					}
					if (response.rackloadDetails && response.rackloadDetails.length > 0) {
						this.rackloadDetails = response.rackloadDetails || [];
					} else {
						this.rackloadDetails = [];
					}
				}
			});
	}

	// get totalBills_count(): number {
	//   return this.routewise.length + this.billwise.length
	// }

	trackByFnBillWise(index: number, item: any): number {
		return item.Bill_No;
	}

	trackByFnPendingToAssign(index: number, item: any): number {
		return item.Invoice_No;
	}

	trackByFnpicking(index: number, item: any): number {
		return item.Picker_Name;
	}

	trackByFnchecking(index: number, item: any): number {
		return item.Checker_Name;
	}

	trackByFnDispached(index: number, item: any): number {
		return item.Dispatch_No;
	}

  showhideinvoicesync: any = 1;
	onfromDateChange(event: any): void {
		// console.log('🚀 ~ event:', event)
		// this.selecteDate = event;
		// this.getWarehouseDashboardSummary();
		// this.GetWarehouseDashboardDetail();
		// this.activeWarehouse = 0;
		// this.setactiveWarehouse(this.activeWarehouse);

		let date1 = this.f_chknum(new Date(moment(this.selecteFromDate).format('YYYY-MM-DD')));
		let date2 = this.f_chknum(new Date(moment(this.selecteToDate).format('YYYY-MM-DD')));
		let currentdate = this.f_chknum(new Date(moment(new Date()).format('YYYY-MM-DD')));
		const timeDiff = date2 - date1;
		const timeDiffwithcurrent = date1 - currentdate;
		let dayDiff = Math.abs(timeDiff) / (1000 * 60 * 60 * 24);
		let dayDiffcurrent = Math.abs(timeDiffwithcurrent) / (1000 * 60 * 60 * 24);
		//let diffdays =  Math.ceil(timeDiff / (1000 * 60 * 60 * 24)); // Convert ms to days
		// console.log('Day difference:', dayDiff);

    let currDate = moment(new Date()).format('YYYY-MM-DD');
    let ToDate = moment(this.selecteToDate).format('YYYY-MM-DD');

    if(currDate === ToDate){
      this.showhideinvoicesync = 1;
      this.GetOrderTrackerDashboardData();
    }else{
      this.showhideinvoicesync = 0;
	  this.GetOrderTrackerDashboardData();
    }


		/* if (dayDiffcurrent > 7) {
			this.toastWarningMsg("The day difference should not be less than 7 day.");
			this.selecteDate = new Date();
			// this.selecteFromDate = new Date();
			let newdate1 = new Date();
			this.selecteToDate = new Date();
			newdate1.setDate(this.selecteToDate.getDate() - 1);
			this.selecteFromDate = newdate1;
		} else
		if (dayDiff > 1) {
			this.toastWarningMsg("The day difference should not be less than 1 day.");
			this.selecteDate = new Date();
			// this.selecteFromDate = new Date();
			let newdate1 = new Date();
			this.selecteToDate = new Date();
			newdate1.setDate(this.selecteToDate.getDate() - 1);
			this.selecteFromDate = newdate1;
		} else { */
			// console.log("==========> Date correct");
			// this.GetOrderTrackerDashboardData();
		/* } */

	}

	onDateChange(event: any): void {
		// console.log('🚀 ~ event:', event)
		// this.selecteDate = event;
		// this.getWarehouseDashboardSummary();
		// this.GetWarehouseDashboardDetail();
		// this.activeWarehouse = 0;
		// this.setactiveWarehouse(this.activeWarehouse);

		let date1 = this.f_chknum(new Date(moment(this.selecteFromDate).format('YYYY-MM-DD')));
		let date2 = this.f_chknum(new Date(moment(this.selecteToDate).format('YYYY-MM-DD')));
		let currentdate = this.f_chknum(new Date(moment(new Date()).format('YYYY-MM-DD')));
		const timeDiff = date2 - date1;
		const timeDiffwithcurrent = date1 - currentdate;
		let dayDiff = Math.abs(timeDiff) / (1000 * 60 * 60 * 24);
		let dayDiffcurrent = Math.abs(timeDiffwithcurrent) / (1000 * 60 * 60 * 24);

    let currDate = moment(new Date()).format('YYYY-MM-DD');
    let ToDate = moment(this.selecteToDate).format('YYYY-MM-DD');

    if(currDate === ToDate){
      this.showhideinvoicesync = 1;
      this.GetOrderTrackerDashboardData();
    }else{
      this.showhideinvoicesync = 0;
      this.GetOrderTrackerDashboardData();
    }

		/* if (dayDiffcurrent > 7) {
			this.toastWarningMsg("The date should not be less than 4 day.");
			this.selecteDate = new Date();
			// this.selecteFromDate = new Date();
			let newdate1 = new Date();
			this.selecteToDate = new Date();
			newdate1.setDate(this.selecteToDate.getDate() - 1);
			this.selecteFromDate = newdate1;
		}  else
		if (dayDiff > 1) {
			this.toastWarningMsg("The date difference should not be less than 1 day.");
			this.selecteDate = new Date();
			// this.selecteFromDate = new Date();
			let newdate1 = new Date();
			this.selecteToDate = new Date();
			newdate1.setDate(this.selecteToDate.getDate() - 1);
			this.selecteFromDate = newdate1;
		}  
    else { */
			// console.log("==========> Date correct");
			// this.GetOrderTrackerDashboardData();
		/* } */

	}



	getClass(value: number): string {
		if (value >= 100) return 'pr_green';
		if (value > 50 && value < 100) return 'pr_orange';
		return 'pr_red';
	}

	getRowClass(value: number): string {
		if (value >= 100) return 'pr_light_green';
		if (value > 50 && value < 100) return 'pr_light_orange';
		return 'pr_light_red';
	}

	getBillwiseClass(value: number): string {
		if (value <= 0) return 'pr_green';
		if (value > 0 && value < 4) return 'pr_orange';
		return 'pr_red';
	}
	getBillwiseRowClass(value: number): string {
		if (value <= 0) return 'pr_light_green';
		if (value > 0 && value < 4) return 'pr_light_orange';
		return 'pr_light_red';
	}

	getPickerOfTheDay(pickers: any[]): any {
		// Step 1: Find the max DT value
		let maxDT = Math.max(...pickers.map(picker => picker.DT));

		// Step 2: Filter all pickers having the same min DT
		let maxDTPickers = pickers.filter(picker => this.f_chknum(picker.DT) == this.f_chknum(maxDT));

		// Step 3: Find the picker with the highest Picked_Item_Count in case of tie
		return maxDTPickers.reduce((best, current) =>
			current.Picked_Item_Count > best.Picked_Item_Count ? current : best,
			maxDTPickers[0]
		);
	}

	getCheckerOfTheDay(checkers: any[]): any {
		// Step 1: Find the minimum DT value
		let maxDT = Math.max(...checkers.map(checker => checker.DT));

		// Step 2: Filter all pickers having the same min DT
		let maxDTCheckers = checkers.filter(checker => this.f_chknum(checker.DT) == this.f_chknum(maxDT));

		// Step 3: Find the picker with the highest Checked_Item_Count in case of tie
		return maxDTCheckers.reduce((best, current) =>
			current.Checked_Item_Count > best.Checked_Item_Count ? current : best,
			maxDTCheckers[0]
		);
	}

	getCheckerActiveInactiveCounts(checkers: any[]): any {
		let active = 0;
		let inactive = 0;
		checkers.forEach(checker => {
			if (checker.Status == 'Active') {
				active++;
			} else {
				inactive++;
			}
		});
		return {
			active,
			inactive
		};
	}
	getPickerActiveInactiveCounts(checkers: any[]): any {
		let active = 0;
		let inactive = 0;
		checkers.forEach(checker => {
			if (checker.Status == 'Active') {
				active++;
			} else {
				inactive++;
			}
		});
		return {
			active,
			inactive
		};
	}


	countPerformanceCategories(routes: any[]) {
		return routes.reduce(
			(acc, route) => {
				let performance = parseFloat(route.OTIFPerformance); // Convert string to number

				if (performance >= 100) {
					acc.onTime++;
				} else if (performance > 50 && performance < 100) {
					acc.delay++;
				} else {
					acc.superDelay++;
				}

				return acc;
			}, {
				superDelay: 0,
				delay: 0,
				onTime: 0
			} // ✅ Initial values
		);
	}


	f_chkString(p_value) {
		var Val = (p_value ? p_value.toString() : "").trim();
		return Val;
	}

	f_chknum(p_value) {
		var Val = Number(p_value);
		if (Val) {
			return Val;
		}
		return 0;
	}

	LastRefreshTime: any;
	NextRefreshTime: any;
	onRefresh(): void {
		clearTimeout(this.RefTimeOut);
		this.activeWarehouse = 0;
		this.activeGraph = 0;
		/*     this.getWarehouseDashboardSummary()0
		    this.GetWarehouseDashboardDetail(); */
		this.GetOrderTrackerDashboardData();
		this.LastRefreshTime = this.addZeroToTime(new Date().getHours()) + ':' + this.addZeroToTime(new Date().getMinutes()) + ':' + this.addZeroToTime(new Date().getSeconds());
		// this.OnRefreshTimeChange(this.RefreshTime);
    	this.Get_Order_Tracker_Dashboard_Time_Details();
		this.OnRefreshTimeChange(this.RefreshTime);
		
	}

	addZeroToTime(i) {
		if (i < 10) {
			i = "0" + i;
		}
		return i;
	}

	RefTimeOut: any;
	OverviewTime: any;
	CPTTime: any;
	OrderEmailTime: any;
	SalesEmailTime: any;
	VeryFastInventoryDays: any;
	FastInventoryDays: any;
	MediumInventoryDays: any;
	SlowInventoryDays: any;
	OnRefreshTimeChange(RefreshTime) {
    // console.log("=>", RefreshTime);
		/* if (this.f_chknum(RefreshTime) < 5) {
			this.RefreshTime = this.DefaultRefreshTime;
			this.RefreshTime = this.DefaultRefreshTime;
			this.toastWarningMsg("The time should not be less than 5 minutes");
			return false;
		} */

		RefreshTime = RefreshTime * 1;
		if (!RefreshTime) {
			return;
		}
		clearTimeout(this.RefTimeOut);
		this.RefTimeOut = setTimeout(() => {
			this.onRefresh();
		}, (60000 * RefreshTime));
	}

	autoCycleIndex = -1; // So the first "start" moves us to index=0
	autoCycleTimer: any = null; // Will store the `setTimeout` reference
	tileAutoCycleConfig = [{
			warehouseId: 1,
			interval: 2,
			routeWiseInterval: 2,
			billWiseInterval: 2
		}, // 5 seconds for "Total Bills"
		{
			warehouseId: 2,
			interval: 2
		}, // 10 seconds for "Pending to Assign"
		{
			warehouseId: 3,
			interval: 2
		}, // skip "Picking" tile (0 = skip)
		{
			warehouseId: 4,
			interval: 2
		}, // 7 seconds for "Checking"
		{
			warehouseId: 5,
			interval: 2,
			dispatchRouteInterval: 2,
			dispatchSalesmanInterval: 2
		}, // 5 seconds for "Dispatch"
		{
			warehouseId: 6,
			interval: 2
		}, // 5 seconds for "Dispatch"

	];
	routewiseTileTimer: number = 10; // 10 seconds for "Total Routewise"

	isCycling: boolean = false;
	// startAutoCycle(): void {
	//   // Clear any previous timer
	//   if (this.autoCycleTimer) {
	//     clearTimeout(this.autoCycleTimer);
	//     this.autoCycleTimer = null;
	//   }
	//   // Move index to the next valid tile
	//   do {
	//     this.autoCycleIndex = (this.autoCycleIndex + 1) % this.tileAutoCycleConfig.length;
	//   } while (this.tileAutoCycleConfig[this.autoCycleIndex].interval === 0);

	//   // Get the tile config
	//   const currentTile = this.tileAutoCycleConfig[this.autoCycleIndex];

	//   // Activate that tile via your existing method
	//   this.setactiveWarehouse(currentTile.warehouseId);

	//   // Now schedule the next rotation
	//   // this.autoCycleTimer = setTimeout(() => {
	//   //   this.startAutoCycle();
	//   // }, currentTile.interval * 1000);

	//   // 4. Schedule the next rotation
	//   const interval = currentTile.interval;
	//   if (interval !== 0) {
	//     this.autoCycleTimer = setTimeout(() => {
	//       this.startAutoCycle();
	//     }, interval * 1000);
	//   } else {
	//     // If 0, skip immediately
	//     this.startAutoCycle();
	//   }

	//   this.isCycling = true;  // ✅ Mark as running
	// }

	/* startAutoCycle(): void {
		// 1. Clear existing timer
		if (this.autoCycleTimer) {
			clearTimeout(this.autoCycleTimer);
			this.autoCycleTimer = null;
		}

		// 2. Ensure tileAutoCycleConfig is valid
		if (!this.tileAutoCycleConfig || this.tileAutoCycleConfig.length === 0) {
			console.warn("🚨 tileAutoCycleConfig is empty. Auto-cycle cannot proceed.");
			return;
		}

		// 3. Ensure autoCycleIndex is within valid bounds
		if (this.autoCycleIndex < 0 || this.autoCycleIndex >= this.tileAutoCycleConfig.length) {
			console.warn("🚨 Invalid autoCycleIndex. Resetting to 0.");
			this.autoCycleIndex = 0;
		}

		// 4. Get the current tile safely
		const currentTile = this.tileAutoCycleConfig[this.autoCycleIndex];
		if (!currentTile) {
			console.warn("🚨 Current tile is undefined. Skipping cycle.");
			return;
		}

		console.log(`🔥 Switching to warehouseId: ${currentTile.warehouseId}`);

		// 2. Get the current tile from the cycle
		// const currentTile = this.tileAutoCycleConfig[this.autoCycleIndex];

		// // 3. Special handling for "Total Bill" tile
		// if (currentTile.warehouseId === 1) { // Assuming TB = warehouseId 1
		//   this.setactiveWarehouse(1); // Activate "Total Bill"
		//   this.activeCstabs = 2; // Route Wise
		//   this.setactiveCstabs(2);
		//   this.autoCycleTimer = setTimeout(() => {
		//     this.activeCstabs = 1; // Bill Wise
		//     this.setactiveCstabs(1);
		//     this.autoCycleTimer = setTimeout(() => {
		//       this.moveToNextTile();
		//     }, 10 * 1000); // After 10 seconds, move to next tile
		//   }, 10 * 1000); // After 10 seconds, switch to Bill Wise
		//   return;
		// }
		if (currentTile.warehouseId === 1) { // TB tile
			this.setactiveWarehouse(1);
			this.setactiveCstabs(2); // Route Wise tab
			this.autoCycleTimer = setTimeout(() => {
				this.setactiveCstabs(1); // Switch to Bill Wise tab
				this.autoCycleTimer = setTimeout(() => {
					this.moveToNextTile(); // Move to next tile after 10 sec
				}, currentTile.routeWiseInterval * 60 * 1000);
			}, currentTile.billWiseInterval * 60 * 1000);
			return;
		}

		// 4. Special handling for "Dispatch" tile
		if (currentTile.warehouseId === 5) { // DP tile
			this.setactiveWarehouse(5);
			this.setactiveDispatchTabs(1); // Route Wise tab
			this.autoCycleTimer = setTimeout(() => {
				this.setactiveDispatchTabs(2); // Switch to Salesman Wise tab
				this.autoCycleTimer = setTimeout(() => {
					this.moveToNextTile(); // Move to next tile after 10 sec
				}, currentTile.dispatchSalesmanInterval * 60 * 1000);
			}, currentTile.dispatchRouteInterval * 60 * 1000);
			return;
		}

		// 5. If it's not "Total Bill" or "Dispatch", continue normal cycling
		this.moveToNextTile();
	}

	moveToNextTile(): void {
		// 1. Clear any existing timer
		if (this.autoCycleTimer) {
			clearTimeout(this.autoCycleTimer);
			this.autoCycleTimer = null;
		}

		// 2. Move to the next valid tile
		do {
			this.autoCycleIndex = (this.autoCycleIndex + 1) % this.tileAutoCycleConfig.length;
		} while (this.tileAutoCycleConfig[this.autoCycleIndex].interval === 0);

		// 3. Activate the new tile
		const nextTile = this.tileAutoCycleConfig[this.autoCycleIndex];
		this.setactiveWarehouse(nextTile.warehouseId);
		this.getWarehouseDashboardSummary();
		// 4. Start the next cycle
		const interval = nextTile.interval;
		if (interval !== 0) {
			this.autoCycleTimer = setTimeout(() => {
				this.startAutoCycle();
			}, interval * 60 * 1000);
		} else {
			this.startAutoCycle();
		}

		this.isCycling = true; // ✅ Mark as running
	} */


	@HostListener('window:beforeunload', ['$event'])
	onBeforeUnload(event: Event): void {
		// Clear timer if needed
		if (this.autoCycleTimer) {
			clearTimeout(this.autoCycleTimer);
			this.autoCycleTimer = null;
		}
	}

	toggleAutoCycle(): void {
		if (this.isCycling) {
			// If cycling, stop it
			if (this.autoCycleTimer) {
				clearTimeout(this.autoCycleTimer);
				this.autoCycleTimer = null;
			}
			this.isCycling = false; // 🚫 Mark as paused
		} else {
			// If paused, restart the cycle
			// this.startAutoCycle();
		}
	}

	// get tableHeaders(): string[] {
	//   return this.rackLoadData.length > 0 ? Object.keys(this.rackLoadData[0]) : [];
	// }

	// generateColumns(data: any[]) {
	//   let columnDefinitions = [];
	//   data.map(object => {
	//     Object
	//       .keys(object)
	//       .map(key => {
	//         let mappedColumn = {
	//           headerName: key.toUpperCase(),
	//           field: key,
	//           width: 70,
	//           cellStyle: { 'textAlign': "right" }
	//         }
	//         columnDefinitions.push(mappedColumn);
	//       })
	//   })
	//   columnDefinitions = columnDefinitions.filter((column, index, self) =>
	//     index === self.findIndex((colAtIndex) => (
	//       colAtIndex.field === column.field
	//     ))
	//   )
	//   return columnDefinitions;
	// }

	get tableHeaders(): string[] {
		return this.RackLoadData.map(item => item.Bin_Name); // Extract Bin_Name as headers
	}

	get tableValues(): number[] {
		return this.RackLoadData.map(item => item.Bin_Count); // Extract Bin_Count as row values
	}


	get tableHeaderDetails(): string[] {
		return this.rackloadDetails.map(item => item.Bin_Name); // Extract Bin_Name as headers
	}

	get tableValueDetails(): number[] {
		return this.rackloadDetails.map(item => item.Bin_Count); // Extract Bin_Count as row values
	}


	getBinDetails(Type = "RL", SubType = "DL", Bin_Name): void {
		const requestPayload = {
			"Company_ID": this.unitInfo.Company_ID,
			"Unit_ID": this.unitInfo.Unit_ID,
			"Doc_Date": moment(this.selecteDate).format('YYYY-MM-DD'),
			"Type": Type,
			"SubType": SubType,
			"Bin_Name": Bin_Name
		};
		this.busy = this.http.post('api/warehouses/GetWarehouseDashboardDetail', requestPayload)
			.subscribe((response: any = {
				rackloadDetails: []
			}) => {
				if (response.rackloadDetails && response.rackloadDetails.length > 0) {
					this.rackloadDetails = response.rackloadDetails || [];
				} else {
					this.rackloadDetails = [];
				}
			});
	}
	selectedCellIndex: any;
	getBinDetailsUsingHeader(header: string, index = 0): void {
		this.getBinDetails("RL", "DL", header);
		console.log('clicked::', header);
		this.selectedCellIndex = index; // Store the clicked cell index
	}

	editedConfig: any[] = [];
	validationErrors: {
		[key: string]: boolean
	} [] = [];

	openCycleConfig(): void {
		this.validationErrors = this.editedConfig.map(() => ({}));
		this.editedConfig = JSON.parse(JSON.stringify(this.tileAutoCycleConfig));
		// this.validationErrors = new Array(this.editedConfig.length).fill(false);


		this.cycleConfigReference = this.modalService.open(this.CycleConfig, {
			size: 'lg',
			windowClass: 'data-show width-60 height-400',
			centered: true,
			keyboard: true,
			backdrop: 'static',
		});
    setTimeout(() => {
      this.dashboarsettings.RefreshTime = this.f_chknum(this.RefreshTime);
      this.dashboarsettings.OverviewTime = this.f_chknum(this.OverviewTime);
      this.dashboarsettings.CPTTime = this.f_chknum(this.CPTTime);
      this.dashboarsettings.OrderEmailTime = this.f_chknum(this.OrderEmailTime);
      this.dashboarsettings.SalesEmailTime = this.f_chknum(this.SalesEmailTime);
      this.dashboarsettings.VeryFastInventoryDays = this.f_chknum(this.VeryFastInventoryDays);
      this.dashboarsettings.FastInventoryDays = this.f_chknum(this.FastInventoryDays);
      this.dashboarsettings.MediumInventoryDays = this.f_chknum(this.MediumInventoryDays);
      this.dashboarsettings.SlowInventoryDays = this.f_chknum(this.SlowInventoryDays);
    }, 200);

		this.cycleConfigReference.result.then((result) => {
			console.log('result', result);
		}, (reason) => {
			console.log('reason', reason);
		});
	}

	// validateInput(index: string): void {

	//   const value = this.f_check_number(this.editedConfig[index].interval);
	//   this.validationErrors[index] = !(Number.isInteger(value) && value >= 0);
	// }

	validateInput(index: number, field: 'interval' | 'billWiseInterval' | 'routeWiseInterval' | 'dispatchRouteInterval' | 'dispatchSalesmanInterval'): void {
		if (!this.validationErrors[index]) {
			this.validationErrors[index] = {}; // Ensure object exists
		}

		const value = this.f_check_number(this.editedConfig[index][field]);
		this.validationErrors[index][field] = !(Number.isInteger(value) && value >= 0);
	}
	// OkClicked() {
	//   // if (this.validationErrors.some(err => err)) {
	//   //   this.toastWarningMsg("Please correct invalid values before saving.");
	//   //   return;
	//   // }
	//   const isValid = this.editedConfig.every(config => 
	//     this.f_check_number(config.interval) && this.f_check_number(config.interval) >= 0 &&
	//     (config.routeWiseInterval === undefined || (this.f_check_number(config.routeWiseInterval) && this.f_check_number(config.routeWiseInterval) >= 0)) &&
	//     (config.billWiseInterval === undefined || (this.f_check_number(config.billWiseInterval) && this.f_check_number(config.billWiseInterval) >= 0))
	//   );

	//   if (!isValid) {
	//     this.toastWarningMsg("Please correct invalid values before saving.");
	//     return;
	//   }

	//   // if (this.validationErrors.some(err => Object.values(err).some(value => value))) {
	//   //   this.toastWarningMsg("Please correct invalid values before saving.");
	//   //   return;
	//   // }
	//   console.log("JSON.parse(JSON.stringify(this.editedConfig))", JSON.parse(JSON.stringify(this.editedConfig)));

	//   this.tileAutoCycleConfig = JSON.parse(JSON.stringify(this.editedConfig));
	//   this.toastWarningMsg("Configuration saved successfully.");
	//   this.cycleConfigReference.close();
	//   this.startAutoCycle();
	// }

	toast = Swal.mixin({
		toast: true,
		position: 'center',
		showConfirmButton: false,
		timer: 3000,
		backdrop: `rgba(30, 30, 37, 0.4)`
	});
	toastWarningMsg(msg) {
		this.toast({
			type: 'warning',
			title: msg
		});
	}

	warehouseNames: {
		[key: number]: string
	} = {
		1: "Total Billwise",
		2: "Pending to Assign",
		3: "Picking",
		4: "Checking",
		5: "Dispatch",
		6: "Row Load",
		7: "Total Routewise"
	};

	getWarehouseName(warehouseId: number): string {
		return this.warehouseNames[warehouseId] || "Unknown";
	}

	f_check_string(p_value) {
		if (p_value == undefined || p_value === '' || p_value === null || p_value !== p_value) {
			return "";
		} else {
			return p_value;
		}
	}
	f_check_number(p_value) {
		if (p_value == undefined || p_value === '' || p_value === null || p_value !== p_value) {
			return 0;
		} else {
			return Number(p_value);
		}
	}


	/* phoneNumber:any  = '';
	message:any  = '';
	sendWhatsAppMessage() {
	  // this.phoneNumber = 9714651374;
	  // this.message = "This is from Entero";
	  // const formattedMessage = encodeURIComponent(this.message);
	  // const whatsappUrl = `https://wa.me/${this.phoneNumber}?text=${formattedMessage}`;
	  // window.open(whatsappUrl, '_blank');
	  this.sendMessage();
	}

	sendMessage = async () => {
	  const token = 'YOUR_ACCESS_TOKEN';
	  const phoneNumber = '+919714651374';
	  const message = 'Hello, this is a test message!';
	
	  try {
	    const response = await axios.post('https://graph.facebook.com/v18.0/YOUR_PHONE_NUMBER_ID/messages', {
	      messaging_product: 'whatsapp',
	      to: phoneNumber,
	      type: 'text',
	      text: { body: message },
	    }, {
	      headers: {
	        'Authorization': `Bearer ${token}`,
	        'Content-Type': 'application/json'
	      }
	    });
	
	    console.log('Message sent:', response.data);
	  } catch (error) {
	    console.error('Error sending message:', error.response.data);
	  }
	}; */

	TotalOrderCount: any = 0;
	TotalInvoiceCount: any = 0;
	TotalPendingOrderCount: any = 0;
	TotalFailedOrderCount: any = 0;
	TotalPickedCount: any = 0;
	TotalNotPickedCount: any = 0;
	LastInvoiceConvertedTime: any = 0;
	LastOrderTime: any = 0;
	diffTimeblink: any = 0;
	synccount: any = 0;
	pendingsynccount: any = 0;
	TotalCancelInvoiceCount: any = 0;
	GetOrderTrackerDashboardData() {
		const reqPayload = {
			Unit_ID: this.unitInfo.Unit_ID,
			Company_ID: this.unitInfo.Company_ID,
			FromDate: moment(this.selecteFromDate).format('YYYY-MM-DD'),
			ToDate: moment(this.selecteToDate).format('YYYY-MM-DD'),
      DashType: this.DashnosrdType
		};

		this.busy = this.http.post('api/warehouses/GetOrderTrackerDashboardData', reqPayload)
			.subscribe((OTDresponse: {
				Total_Counts: any[]

			}) => {
				// console.log("========>", OTDresponse);
				this.TotalOrderCount = OTDresponse.Total_Counts[0].OrderCount;
				this.TotalInvoiceCount = OTDresponse.Total_Counts[0].InvoiceCount;
				this.TotalCancelInvoiceCount = OTDresponse.Total_Counts[0].CancelledInvoice;
				this.TotalPendingOrderCount = OTDresponse.Total_Counts[0].PendingCount;
				this.TotalFailedOrderCount = OTDresponse.Total_Counts[0].FaliedCount;
				this.TotalPickedCount = OTDresponse.Total_Counts[0].PickedCount;
				this.TotalNotPickedCount = this.f_chknum(this.TotalInvoiceCount) - this.f_chknum(this.TotalPickedCount);
				this.LastInvoiceConvertedTime = OTDresponse.Total_Counts[0].LastInvoiceCreatedOn;
				this.LastOrderTime = OTDresponse.Total_Counts[0].LastOrderDate;
				this.diffTime = OTDresponse.Total_Counts[0].DiffInMins;
				this.diffTimeblink = Math.abs(OTDresponse.Total_Counts[0].DiffInMins);


				let LastDate = moment(this.LastInvoiceConvertedTime).format('YYYY-MM-DD HH:MM:SS');
				let CurrentDate = moment(new Date()).format('YYYY-MM-DD HH:MM:SS');
				// this.diffTime = this.getTimeDifferenceInMinutes(LastDate, CurrentDate);
				if(this.showhideinvoicesync == 1){
					this.getEDSyncInvoices();
				}

				let timediffrence = this.diffTime;
				// this.OrderEmailTime
				// this.SalesEmailTime
				if(this.f_chknum(timediffrence) > 0 && this.f_chknum(timediffrence) >= this.f_chknum(this.OrderEmailTime)){
				this.Sendmail(1, timediffrence);
				}

				if(this.f_chknum(timediffrence) < 0 && this.f_chknum(Math.abs(timediffrence)) >= this.f_chknum(this.SalesEmailTime)){
				this.Sendmail(2, Math.abs(timediffrence));
				}

				if(this.f_check_string(this.DashnosrdType) == "CPT"){
					this.setGraph(2);
				}else{
					this.Get_Order_Tracker_Dashboard_Stats_OrderVsSales();
					this.Get_Order_Tracker_Dashboard_Stats_ShortExcessStockRatio();
					this.setGraph(1);
				}
			})
	}

	getTimeDifferenceInMinutes(date1, date2) {
		let d1 = new Date(date1);
		let d2 = new Date(date2);

		const timeDiff = Math.abs(this.f_chknum(d2.getTime()) - this.f_chknum(d1.getTime())); // Ensure valid time difference
		return Math.floor(timeDiff / (1000 * 60)); // Convert milliseconds to minutes
	}

	convertMinutesToTimeFormat(minutes: number): string {
		if (minutes < 60) {
			return `${minutes} min`;
		}
		const hours = Math.floor(minutes / 60);
		const remainingMinutes = minutes % 60;
		return `${hours}:${remainingMinutes.toString().padStart(2, '0')} hr`;
	}

	edBearerTokenEDsync: any = {};
	headers: any;
	headers1: any;
	SetEDsyncRequestToken: any;
	EDInvoiceData: any;
	EDInvoiceDataForERP: any = [];
	LoginED() {
		if (this.f_chknum(this.unitInfo.Stockist_ID) == 0) {
			this.toastWarningMsg("Please Add Stockist ID, for Selected Unit");
			return false;
		}

		this.headers = new HttpHeaders({
			'Content-Type': 'application/json; charset=utf-8',
			'Access-Control-Allow-Origin': '*',
			'Origin': 'https://www.enterodirect.com'
		});


		if (this.f_chknum(this.unitInfo.Stockist_ID) != 1249) {
			let data1 = {
				"email": "edsync",
				"password": "123456"
			};
			this.busy = this.http.post('https://www.enterodirect.com/auth/local', data1)
				.subscribe(response => {
					this.edBearerTokenEDsync = response;
					this.SetEDsyncRequestToken = {
						"x-auth-token": this.edBearerTokenEDsync.token
					};
					setTimeout(() => {
						$('#InvoiceResyncManualText-filter-text-box').focus();
					}, 300);
				});
		} else {
			let data1 = {
				"email": "erpperf",
				"password": "123456"
			};
			this.busy = this.http.post('https://uatreplica.enterodirect.com/auth/local', data1)
				.subscribe(response => {
					this.edBearerTokenEDsync = response;
					this.SetEDsyncRequestToken = {
						"x-auth-token": this.edBearerTokenEDsync.token
					};
					setTimeout(() => {
						$('#InvoiceResyncManualText-filter-text-box').focus();
					}, 300);
				});
		}
	}

	getEDSyncInvoices(objindex: any = 0, Is_AutoProcess: any = 0) {
		if (this.f_chknum(this.unitInfo.Stockist_ID) == 0) {
			this.toastWarningMsg("Please Add Stockist ID, for Selected Unit");
			return false;
		}
		this.tiles.loading = true;
		setTimeout(() => {
			var myDate = new Date();
			let baseUrl = "https://www.enterodirect.com/api/ERPServicess/GetInvoiceByDate";
			myDate = moment(this.selecteFromDate).format('YYYY-MM-DD');

			if (this.f_chknum(this.unitInfo.Stockist_ID) != 1249) {
				baseUrl = baseUrl;
			} else {
				baseUrl = "https://uatreplica.enterodirect.com/api/ERPServicess/GetInvoiceByDate";
			}

			let data = {
				"date": myDate,
				"stockistID": this.unitInfo.Stockist_ID,
				"token": this.edBearerTokenEDsync.token,
				"baseUrl": baseUrl,
			};

			this.http.post('/api/adminanalyzes/GetInvoiceByDate', data)
				.subscribe((result: any) => {
					this.EDInvoiceData = result;
					this.EDInvoiceDataForERP = this.EDInvoiceData.map(item => ({
						SIHId: item.SIHId
					}));
					if (this.EDInvoiceDataForERP.length === this.EDInvoiceData.length) {
						this.CheckResyncData();
					}

					/* let startDate = moment(this.selecteFromDate, 'YYYY-MM-DD').startOf('day');
					let endDate = moment(this.selecteToDate, 'YYYY-MM-DD').endOf('day')
					//  console.log("==============Filter Data=======>", startDate.format('YYYY-MM-DD'), "===>", endDate.format('YYYY-MM-DD'));

					 let filteredList = this.EDInvoiceData.filter((item) => {
					  let invoiceDate = moment(item.InvoiceDate, 'YYYY-MM-DD').startOf('day');
					  return invoiceDate.isBetween(startDate, endDate, null, '[]'); // Include both start and end dates
					});

					// console.log("==============Filtered Data=======>", filteredList); 
					this.synccount = this.f_chknum(filteredList.length);
					this.pendingsynccount = this.f_chknum(this.TotalInvoiceCount) - this.synccount; */

				});

		}, 500);
	}

	ResyncDetails: any = [];
	ResyncDataforrepushed: any = [];
	EDDATASync: any = 0;
	CheckResyncData() {
		this.ResyncDataforrepushed = [];
		let data1 = {
			data: this.EDInvoiceDataForERP,
			Unit_ID: this.unitInfo.Unit_ID,
			Company_ID: this.unitInfo.Company_ID,
			FromDate: moment(this.selecteFromDate).format('YYYY-MM-DD'),
			ToDate: moment(this.selecteToDate).format('YYYY-MM-DD'),
		};
		this.http.post('/api/warehouses/Get_Order_Tracker_Dashboard_Stats_Sync_Invoice', data1)
			.subscribe(response => {
				this.ResyncDataforrepushed = response;
				// this.RepushGridAPI.refreshCells();
				// this.EDDATASync = 1;
				//  console.log("====-=====", this.ResyncDataforrepushed);

				this.synccount = this.f_chknum(this.ResyncDataforrepushed[0].SyncedInvoiceCount);
				this.pendingsynccount = this.f_chknum(this.ResyncDataforrepushed[0].NotSyncedInvoiceCount);
				this.tiles.loading = false;
			});
	}

	headerCSV: any = [];
	lineItemCSV: any = [];
	public ledgerEntriesColumnDef: any = [];
	public rowClassRules: any;
	public lastIndex: any;
	public ledgerfooterData: any;
	resp: any = [];
	TotalRowData: any;
	GroupData: any = [];
	GroupDataFilter: any = [];
	filterValue: any;
	// getCostCentreExpnseReport1() {
	GetOrderTrackerDashboardStatsDetails() {
		if (!this.f_check_string(this.GetDataType)) {
			this.GroupData = [];
			this.ledgerEntriesColumnDef = [];
			return false;
		}
		// this.ledgerEntriesColumnDef = [];
    this.Invoice_Filter_Type = 'C';
		let payload = {
			"Company_ID": this.unitInfo.Company_ID,
			"Unit_ID": this.unitInfo.Unit_ID,
			"FinYear": this.unitInfo.Fyear,
			"FromDate": moment(this.selecteFromDate).format('YYYY-MM-DD'),
			"ToDate": moment(this.selecteToDate).format('YYYY-MM-DD'),
			"Type": this.GetDataType
		}
		var self = this;
		this.busy = this.http.post('/api/warehouses/Get_Order_Tracker_Dashboard_Stats_Details', payload)
			.subscribe((response: any = Array()) => {
				// this.headerCSV = response.HeaderEntries;
				// this.lineItemCSV = response.DataEntries;

				this.resp = response;
				this.GroupData = [];
				this.GroupData = this.resp;
				this.GroupDataFilter = this.resp;
				this.ledgerEntriesColumnDef = [];

					if(this.GetDataType == 'Invoice' && self.f_chkString(this.Invoice_Filter_Type) === 'C'){
					this.GroupData = this.GroupDataFilter.filter(function (item) {
						return self.f_chknum(item.Invoice_Amount) === 0
					});
					}else{
					this.GroupData = this.GroupDataFilter;
					}

				// create column defination using api response
				response.forEach((element, index) => {
					if (index == 0) {
						Object.keys(element).forEach((key) => {
							// console.log("=>=>", key);
							self.ledgerEntriesColumnDef.push({
								headerName: key,
								field: key,
							});
							/* self.TotalRowData = {
							    ...self.TotalRowData, [key]: (self.GroupData.reduce(function (acc, sum) {
							        return (acc + parseFloat(sum[key]));
							    }, 0)).toFixed(2)
							}; */
						});
					}
				});
				// console.log("ledgerEntriesColumnDef::", this.ledgerEntriesColumnDef);
				/* setTimeout(() => {
				    self.TotalRowData.Ledger = 'Grand Total';
				    this.gridApiLedgerEntries.setPinnedBottomRowData([self.TotalRowData]);
				}, 500); */
				setTimeout(() => {
					this.gridColumnApiLedgerEntries.getAllColumns().forEach(function(column) {
						self.gridColumnApiLedgerEntries.autoSizeColumn(column);
						/*if (column.getColId() == 'Ledger' || column.getColId() == 'Account'){
						    column.setColDef({ headerName: 'Account', field: 'Ledger', width: column.getActualWidth() - 10 }, {});
						    column.setPinned(true);
						} */

					});

					this.filterValue = '';
				}, 800);
			});
	}

	public gridApiLedgerEntries: any;
	public gridColumnApiLedgerEntries: ColumnApi;
	onGridReadyLedgerEntries(params) {
		this.gridApiLedgerEntries = params.api;
		this.gridColumnApiLedgerEntries = params.columnApi;
	}

	OrderVsSalesData: any = [];
	Total_Bills_Graph: any = [];
	Get_Order_Tracker_Dashboard_Stats_OrderVsSales() {
		this.ResyncDataforrepushed = [];
		let data1 = {
			data: this.EDInvoiceDataForERP,
			Unit_ID: this.unitInfo.Unit_ID,
			Company_ID: this.unitInfo.Company_ID,
			FromDate: moment(this.selecteFromDate).format('YYYY-MM-DD'),
			ToDate: moment(this.selecteToDate).format('YYYY-MM-DD'),
		};
		this.http.post('/api/warehouses/Get_Order_Tracker_Dashboard_Stats_OrderVsSales', data1)
			.subscribe(response => {
				this.OrderVsSalesData = response;
				this.Total_Bills_Graph = response;
				// this.initTotalBillsGraph(response.Total_Bills_Graph);
				/* let x = this.Total_Bills_Graph.map((item) => item.OrderDate);
				let Order_Count = this.Total_Bills_Graph.map((item) => item.OrderCount);
				let Inv_Count = this.Total_Bills_Graph.map((item) => item.InvoiceCount);
				this.inittotalBills(x, Order_Count, Inv_Count);

				let formattedData = this.Total_Bills_Graph.map(item => {
					let date = new Date(item.OrderDate);
					let month = date.toLocaleString('en-US', {
						month: 'short'
					});
					let day = date.getDate();
					return [`${month}-${day}`, parseFloat(item.Ratio)];
				});

				this.inittotalBillsRatio(formattedData); */
				//this.initTopselling(x, Order_Count, Inv_Count);
			}); // Get_Order_Tracker_Dashboard_Stats_ShortExcessStockRatio
	}

	ShortExcessStockRatio: any = []
	ShortExcessStockRatioDetails: any = []
	ShortExcessStockRatioFilterData: any = []
	Get_Order_Tracker_Dashboard_Stats_ShortExcessStockRatio() {
		this.ShortExcessStockRatio = [];
		let data1 = {
			// data: this.EDInvoiceDataForERP,
			Unit_ID: this.unitInfo.Unit_ID,
			Company_ID: this.unitInfo.Company_ID,
			FromDate: moment(this.selecteFromDate).format('YYYY-MM-DD'),
			ToDate: moment(this.selecteToDate).format('YYYY-MM-DD'),
		};
		this.http.post('/api/warehouses/Get_Order_Tracker_Dashboard_Stats_ShortExcessStockRatio', data1)
			.subscribe((OTDsresponse: {
				Total_Counts: any[]
				Counts_Details: any[]

			}) => {
				this.ShortExcessStockRatio = OTDsresponse.Total_Counts;
				this.ShortExcessStockRatioDetails = OTDsresponse.Counts_Details;
				this.sortExcessRationData = OTDsresponse.Total_Counts;
				this.sortExcessRationDetails = OTDsresponse.Counts_Details;
				// this.setGraph(2);
			});
	}

	StockRatioColumnDef: any = [];
	SortType: any = '';
	SortQtyRow: any = 0;
	ExcessQtyRow: any = 0;
	clickStockRatio(x) {
		this.ShortExcessStockRatioFilterData = [];
		this.StockRatioColumnDef = [];
		this.SortType = this.f_check_string(x);
		var self = this;
		this.ShortExcessStockRatioFilterData = this.sortExcessRationDetails.filter(picker => this.f_check_string(picker.Moving_Status) == this.f_check_string(x));
		this.SortQtyRow = this.ShortExcessStockRatioFilterData.filter(picker => this.f_check_number(picker['Short Stock']) > 0);
		this.ExcessQtyRow = this.ShortExcessStockRatioFilterData.filter(picker => this.f_check_string(picker['Excess Stock']) > 0);


		this.ShortExcessStockRatioFilterData.forEach((element, index) => {
			if (index == 0) {
				Object.keys(element).forEach((key) => {
					// console.log("=>=>", key);
					self.StockRatioColumnDef.push({
						headerName: key,
						field: key,
					});
				});
			}
		});
		console.log("StockRatioColumnDef::", this.StockRatioColumnDef);
		setTimeout(() => {
			this.openStockRatio();
		}, 300);

		/* 
		 */

	}

	public gridApiStockRatio: any;
	public gridColumnApiStockRatio: ColumnApi;
	onGridReadyStockRatio(params) {
		this.gridApiStockRatio = params.api;
		this.gridColumnApiStockRatio = params.columnApi;
	}

	openStockRatio(): void {
		// this.StockRatioReference = this.modalService.open(this.RatioDetails, {
		// 	size: 'lg',
		// 	windowClass: 'data-show width-80',
		// 	centered: true,
		// 	keyboard: true,
		// 	backdrop: 'static',
		// });
    this.StockRatioReference = this.modalService.open(this.RatioDetails, { size: 'sm', windowClass: 'data-show _rightmodal fade Ordertracker visit1', backdropClass: 'top96' });
		var self = this;

		var TotalRowData = { "ProductID": 'Total Count: ' ,"Product_Code": this.ShortExcessStockRatioFilterData.length};
		// var TotalRowData = { "ProductID": 'Total Count: ' ,"Product_Code": this.ShortExcessStockRatioFilterData.length, "Short Ratio%":  this.SortQtyRow.length, "Excess Ratio%" : this.ExcessQtyRow.length };
		setTimeout(() => {
			this.gridApiStockRatio.setPinnedBottomRowData([TotalRowData]);
		}, 300);
		setTimeout(() => {
			this.gridColumnApiStockRatio.getAllColumns().forEach(function(column) {
				self.gridColumnApiStockRatio.autoSizeColumn(column);
			});

			this.searchAT = '';
			$('#search_AT').focus();
		}, 1000);
		this.StockRatioReference.result.then((result) => {
			console.log('result', result);
		}, (reason) => {
			console.log('reason', reason);
		});
	}

	OkClicked() {
		console.log("Wellcome to Export");
		let d = new Date();
		var fName = 'Short Excess Stock Ratio Details ' + this.SortType;
		var params = {
			columnGroups: true,
			skipFooters: false,
			allColumns: true,
			// customFooter: this.ledgerfooterData1,
			fileName: fName,
		};
		this.gridApiStockRatio.exportDataAsCsv(params);
	}

	searchAT: any = '';
	onSerachBoxFilterChangedAT() {
		let value = $('input#search_AT').val();
		this.gridApiStockRatio.setQuickFilter(value);
	};


  chart: any;
  CPTDATAList: any = [];
  CPTGraphData: any = [];
  setGraph(graphNumber: number) {
    this.activeGraph = graphNumber;
   /*  let x = this.ShortExcessStockRatio.map((item) => item.Slab);
    let ShortRatio = this.ShortExcessStockRatio.map((item) => item.ShortRatio);
    let ExcessRatio = this.ShortExcessStockRatio.map((item) => item.ExcessRatio);
    console.log("===================StockRatio===>", x, ShortRatio, ExcessRatio);

    if (this.chart) {
      this.chart.destroy(); // Destroy existing chart before reinitializing
    }

    setTimeout(() => {
      if (this.activeGraph === 2 && document.getElementById("CPTDATA")) {
        this.CPTDATAList=[];
        this.CPTGraphData=[];
        let data1 = {
          // data: this.EDInvoiceDataForERP,
          Unit_ID: this.unitInfo.Unit_ID,
          Company_ID: this.unitInfo.Company_ID,
          FromDate: moment(this.selecteFromDate).format('YYYY-MM-DD'),
          ToDate: moment(this.selecteToDate).format('YYYY-MM-DD'),
        };
        this.http.post('/api/warehouses/Get_Order_Tracker_Dashboard_Stats_CPT', data1)
        .subscribe((response1:any) => {
          this.CPTDATAList = response1;
          this.CPTGraphData = response1;
          // let z = this.CPTGraphData.map((item) => moment(item.CPTDate).format('YYYY-MM-DD HH:MM:SS'));
          let z = this.CPTGraphData.map((item) => item.CPTDate);
          let OrdersCount = this.CPTGraphData.map((item) => item.OrdersCount);
          let InvoiceCount = this.CPTGraphData.map((item) => item.InvoiceCount);
          let PendingCount = this.CPTGraphData.map((item) => item.PendingCount);
          let FailedCount = this.CPTGraphData.map((item) => item.FailedCount);
          let PickedCount = this.CPTGraphData.map((item) => item.PickedCount);
          let PendingPicked = this.CPTGraphData.map((item) => item.PendingPicked);

          console.log("===================StockRatio===>", z,OrdersCount,InvoiceCount,PendingCount,FailedCount,PickedCount,PendingPicked);

        //   this.initTCPTDATA(z,OrdersCount,InvoiceCount,PendingCount,FailedCount,PickedCount,PendingPicked);
        });
        
      } else if (!document.getElementById("CPTDATA")) {
        let y = this.Total_Bills_Graph.map((item) => item.OrderDate);
        let Order_Count = this.Total_Bills_Graph.map((item) => item.OrderCount);
        let Inv_Count = this.Total_Bills_Graph.map((item) => item.InvoiceCount);

        // this.inittotalBills(y, Order_Count, Inv_Count);

        let formattedData = this.Total_Bills_Graph.map((item) => {
          let date = new Date(item.OrderDate);
          let month = date.toLocaleString('en-US', { month: 'short' });
          let day = date.getDate();
          return [`${month}-${day}`, parseFloat(item.Ratio)];
        });

        // this.inittotalBillsRatio(formattedData);
        // this.initTopselling(x, ShortRatio, ExcessRatio);
      }
    }, 0); // Ensure DOM is ready before chart initialization */
  }
 
  mailtype:any;
  massage:any;
  mailSub:any;
  Sendmail(MailType, Mins){
    if(this.f_chknum(MailType) == 1) {
      this.mailSub = 'Order Conversion Failer';
      this.mailtype = 'Invoice';
      this.massage = "Orders have not been converted to invoices for the past "+ this.convertMinutesToTimeFormat(Mins) +". Please check the system";
    }else{
      this.mailSub = 'Order Receving Failer';
      this.mailtype = 'Order';
      this.massage = "Orders have not been received past "+ this.convertMinutesToTimeFormat(Mins) + ". Please check the system";
    }

    let data1 = {
      tosendmail: this.emaildate.To_EmailID,
      // tosendmail: 'prasad.navanath@ehspl.com',
      email: {"MESSAGE_ID": this.mailSub, "MESSAGE":this.massage },
      unitid:this.unitInfo.Unit_ID, companyid: this.unitInfo.Company_ID, Type:this.mailtype,
      emailHost:this.emaildate.Host,
      emailPass:this.emaildate.Pass,
      emailEmailID:this.emaildate.EmailID,
      emailUsername:this.emaildate.Username,
      emailPort:this.emaildate.Port,
    };
    this.http.post('/api/warehouses/Send_Order_Tracker_Dashboard_Mail', data1)
    .subscribe((response1:any) => {
      // console.log("==============>", response1);
    });
  }

  emaildate: any;
  GetSmtpLoginDetailsOrder_Tracker_Dashboard_Mail(){
    let data1 = {"unitid":this.unitInfo.Unit_ID, "companyid": this.unitInfo.Company_ID, "department":"Dashboard" ,"secondary_department":"Dashboard" };
    this.http.post('/api/warehouses/GetSmtpLoginDetailsOrder_Tracker_Dashboard_Mail', data1)
    .subscribe((response1:any) => {
      this.emaildate = response1[0];
      // console.log("========emaildate======>", this.emaildate);
    });
  }

  DashboarSettingsClicked(){
    let data = {
      Company_ID: this.unitInfo.Company_ID, Unit_ID: this.unitInfo.Unit_ID, TimeData: [
        {Dashboard_Type: 'OrderTracker', PanelType: 'RefreshTime', Mins: this.f_chknum(this.dashboarsettings.RefreshTime)},
        {Dashboard_Type: 'OrderTracker', PanelType: 'OverviewTime', Mins: this.f_chknum(this.dashboarsettings.OverviewTime)},
        {Dashboard_Type: 'OrderTracker', PanelType: 'CPTTime', Mins: this.f_chknum(this.dashboarsettings.CPTTime)},
        {Dashboard_Type: 'OrderTracker', PanelType: 'OrderEmailTime', Mins: this.f_chknum(this.dashboarsettings.OrderEmailTime)},
        {Dashboard_Type: 'OrderTracker', PanelType: 'SalesEmailTime', Mins: this.f_chknum(this.dashboarsettings.SalesEmailTime)},
        {Dashboard_Type: 'OrderTracker', PanelType: 'VeryFastInventoryDays', Mins: this.f_chknum(this.dashboarsettings.VeryFastInventoryDays)},
        {Dashboard_Type: 'OrderTracker', PanelType: 'FastInventoryDays', Mins: this.f_chknum(this.dashboarsettings.FastInventoryDays)},
        {Dashboard_Type: 'OrderTracker', PanelType: 'MediumInventoryDays', Mins: this.f_chknum(this.dashboarsettings.MediumInventoryDays)},
        {Dashboard_Type: 'OrderTracker', PanelType: 'SlowInventoryDays', Mins: this.f_chknum(this.dashboarsettings.SlowInventoryDays)},
      ]
    }

    this.http.post('/api/warehouses/Save_Order_Tracker_Dashboard_Time_Details', data)
    .subscribe((response1:any) => {
      // console.log("==============>", response1);
      if(response1[0].flag == 1){
        this.toastWarningMsg(response1[0].msg);
        this.RefreshTime = this.f_chknum(this.dashboarsettings.RefreshTime);
        this.OverviewTime = this.f_chknum(this.dashboarsettings.OverviewTime);
        this.CPTTime = this.f_chknum(this.dashboarsettings.CPTTime);
        this.OrderEmailTime = this.f_chknum(this.dashboarsettings.OrderEmailTime);
        this.SalesEmailTime = this.f_chknum(this.dashboarsettings.SalesEmailTime);
        this.VeryFastInventoryDays = this.f_chknum(this.dashboarsettings.VeryFastInventoryDays);
        this.FastInventoryDays = this.f_chknum(this.dashboarsettings.FastInventoryDays);
        this.MediumInventoryDays = this.f_chknum(this.dashboarsettings.MediumInventoryDays);
        this.SlowInventoryDays = this.f_chknum(this.dashboarsettings.SlowInventoryDays);
        this.onRefresh();
      }
    });
  }

  Get_Order_Tracker_Dashboard_Time_Details(){
    let data = {Company_ID: this.unitInfo.Company_ID, Unit_ID: this.unitInfo.Unit_ID}

    this.http.post('/api/warehouses/Get_Order_Tracker_Dashboard_Time_Details', data)
    .subscribe((response1:any) => {
      // console.log("==============>", response1);

      let RefreshTime = response1.filter(function (item) {
        return item.PanelType === 'RefreshTime'
      });
      this.dashboarsettings.RefreshTime = this.f_chknum(RefreshTime[0].Mins);
      this.RefreshTime  =    this.f_chknum(RefreshTime[0].Mins);
      
      let OverviewTime = response1.filter(function (item) {
        return item.PanelType === 'OverviewTime'
      });
      this.dashboarsettings.OverviewTime = this.f_chknum(OverviewTime[0].Mins);
      this.OverviewTime  =    this.f_chknum(OverviewTime[0].Mins);
      
      let CPTTime = response1.filter(function (item) {
        return item.PanelType === 'CPTTime'
      });
      this.dashboarsettings.CPTTime = this.f_chknum(CPTTime[0].Mins);
      this.CPTTime  =    this.f_chknum(CPTTime[0].Mins);
      
      let OrderEmailTime = response1.filter(function (item) {
        return item.PanelType === 'OrderEmailTime'
      });
      this.dashboarsettings.OrderEmailTime = this.f_chknum(OrderEmailTime[0].Mins);
      this.OrderEmailTime  =    this.f_chknum(OrderEmailTime[0].Mins);
      
	  let SalesEmailTime = response1.filter(function (item) {
        return item.PanelType === 'SalesEmailTime'
      });
      this.dashboarsettings.SalesEmailTime = this.f_chknum(SalesEmailTime[0].Mins);
      this.SalesEmailTime  =    this.f_chknum(SalesEmailTime[0].Mins);

      let VeryFastInventoryDays = response1.filter(function (item) {
        return item.PanelType === 'VeryFastInventoryDays'
      });
      this.dashboarsettings.VeryFastInventoryDays = this.f_chknum(VeryFastInventoryDays[0].Mins);
      this.VeryFastInventoryDays  =    this.f_chknum(VeryFastInventoryDays[0].Mins);

	  let FastInventoryDays = response1.filter(function (item) {
        return item.PanelType === 'FastInventoryDays'
      });
      this.dashboarsettings.FastInventoryDays = this.f_chknum(FastInventoryDays[0].Mins);
      this.FastInventoryDays  =    this.f_chknum(FastInventoryDays[0].Mins);

	  let MediumInventoryDays = response1.filter(function (item) {
        return item.PanelType === 'MediumInventoryDays'
      });
      this.dashboarsettings.MediumInventoryDays = this.f_chknum(MediumInventoryDays[0].Mins);
      this.MediumInventoryDays  =    this.f_chknum(MediumInventoryDays[0].Mins);

	  let SlowInventoryDays = response1.filter(function (item) {
        return item.PanelType === 'SlowInventoryDays'
      });
      this.dashboarsettings.SlowInventoryDays = this.f_chknum(SlowInventoryDays[0].Mins);
      this.SlowInventoryDays  =    this.f_chknum(SlowInventoryDays[0].Mins);
  /* 
      this.dashboarsettings.RefreshTime      = response1[0].filter();
      this.dashboarsettings.OverviewTime     = this.f_chknum(response1[0].OverviewTime);
      this.dashboarsettings.CPTTime          = this.f_chknum(response1[0].CPTTime);
      this.dashboarsettings.OrderEmailTime   = this.f_chknum(response1[0].OrderEmailTime);
      this.dashboarsettings.SalesEmailTime   = this.f_chknum(response1[0].SalesEmailTime);

      this.RefreshTime      = this.f_chknum(response1[0].RefreshTime);
      this.OverviewTime     = this.f_chknum(response1[0].OverviewTime);
      this.CPTTime          = this.f_chknum(response1[0].CPTTime);
      this.OrderEmailTime   = this.f_chknum(response1[0].OrderEmailTime);
      this.SalesEmailTime   = this.f_chknum(response1[0].SalesEmailTime); */
      this.OnRefreshTimeChange(this.RefreshTime);
    });
  }
  
	CPTchartOption: EChartOption = {};
	CPTChartInstance: any;
	demoChartData: any[] = [];
	intervalId: any;
	todayOrder: any[] = [];
	pastOrder: any[] = [];
	futureOrder: any[] = [];
	onCPTChartInitDemo($event) {

		if (this.chart) {
			this.chart.destroy(); // Destroy existing chart before reinitializing
		}

		this.CPTChartInstance = $event;

		this.CPTChartInstance.showLoading();

		let data1 = {
			data: this.EDInvoiceDataForERP,
			Unit_ID: this.unitInfo.Unit_ID,
			Company_ID: this.unitInfo.Company_ID,
			FromDate: moment(new Date()).format('YYYY-MM-DD'),
			ToDate: moment(new Date()).format('YYYY-MM-DD'),
		};
		this.http.post('/api/warehouses/Get_Order_Tracker_Dashboard_Stats_CPT', data1)
			.subscribe((res: any) => {
				this.demoChartData = res;
				this.pastOrder = res.filter(item => moment(item.CPTDate, 'YYYY-MM-DD').format('YYYY-MM-DD') < moment(new Date()).format('YYYY-MM-DD'));
				this.todayOrder = res.filter(item => moment(item.CPTDate, 'YYYY-MM-DD').format('YYYY-MM-DD') == moment(new Date()).format('YYYY-MM-DD'));
				// console.log('Today Order', this.todayOrder);
				this.futureOrder = res.filter(item => moment(item.CPTDate, 'YYYY-MM-DD').format('YYYY-MM-DD') > moment(new Date()).format('YYYY-MM-DD'));
				let self = this;
				this.CPTchartOption = {
					grid: {
						bottom: 30,
						// bottom:10,
						right: 20,
					},
					title: { text: 'CPT Data', subtext: 'Orders, Invoices, Cancel Invoice, Not Invoice, Failed, Picked, Not Pick', show: false },
					tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
					legend: {
						data: ['Orders', 'Invoices', 'Cancel Invoice', 'Not Invoice', 'Failed', 'Picked', 'Not Pick'], type: 'scroll',
						top: 10,
					},
					yAxis: { type: 'category', data: this.todayOrder.map(item => item.CPTDate) },
					xAxis: { type: 'value',
						axisLabel: {
							show: false // Hide x-axis labels
						},					
						axisLine: {
						  show: false // Hide x-axis line
						},
						splitLine: {
						  show: false // Hide grid lines
						} },
					label: {
						show: true,
						valueAnimation: true,
					},
					animationDuration: 500,
					animationEasing: 'cubicOut',
					animationDurationUpdate: 500,
					toolbox: {
						feature: {

							/* myTool2: {
								show: true,
								title: 'Past Orders',
								icon: 'M9.195 18.44c1.25.714 2.805-.189 2.805-1.629v-2.34l6.945 3.968c1.25.715 2.805-.188 2.805-1.628V8.69c0-1.44-1.555-2.343-2.805-1.628L12 11.029v-2.34c0-1.44-1.555-2.343-2.805-1.628l-7.108 4.061c-1.26.72-1.26 2.536 0 3.256l7.108 4.061Z',
								onclick: function () {
									// alert('myToolHandler1');
									console.log('pass order', self.pastOrder);
									self.CPTchartOption.series = [
										{ barMinHeight: 25, name: 'Orders', type: 'bar', stack: 'total', data: self.pastOrder.map(item => item.OrdersCount) },
										{ barMinHeight: 25, name: 'Invoices', type: 'bar', stack: 'total', data: self.pastOrder.map(item => item.InvoiceCount) },
										{ barMinHeight: 25, name: 'Picked', type: 'bar', stack: 'total', data: self.pastOrder.map(item => item.PickedCount) },
										{ barMinHeight: 25, name: 'Not Pick', type: 'bar', stack: 'total', data: self.pastOrder.map(item => item.PendingPicked) },
										{ barMinHeight: 25, name: 'Failed', type: 'bar', stack: 'total', data: self.pastOrder.map(item => item.FailedCount) },
									];
									self.CPTchartOption.yAxis = { type: 'category', data: self.pastOrder.map(item => item.CPTDate) },
										self.CPTchartOption.xAxis = { type: 'value', boundaryGap: [0, 0.01] },
										self.CPTChartInstance.setOption(self.CPTchartOption);
								}
							}, */
							myTool3: {
								show: true,
								title: 'Today Order',
								icon: 'M16.53 11.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z',
								onclick: function () {
									// alert('myToolHandler1')
									console.log('today order', self.todayOrder);
									self.CPTchartOption.series = [
										{ barMinHeight: 25, name: 'Orders', type: 'bar', stack: 'total', data: self.todayOrder.map(item => item.OrdersCount) },
										{ barMinHeight: 25, name: 'Invoices', type: 'bar', stack: 'total', data: self.todayOrder.map(item => item.InvoiceCount) },
										{ barMinHeight: 25, name: 'Cancel Invoice', type: 'bar', stack: 'total', data: self.todayOrder.map(item => item.CancelCount) },
										{ barMinHeight: 25, name: 'Not Invoice', type: 'bar', stack: 'total', data: self.todayOrder.map(item => item.NotInvoice) },
										{ barMinHeight: 25, name: 'Failed', type: 'bar', stack: 'total', data: self.todayOrder.map(item => item.FailedCount) },
										{ barMinHeight: 25, name: 'Picked', type: 'bar', stack: 'total', data: self.todayOrder.map(item => item.PickedCount) },
										{ barMinHeight: 25, name: 'Not Pick', type: 'bar', stack: 'total', data: self.todayOrder.map(item => item.PendingPicked) },
										
									];
									self.CPTchartOption.yAxis = { type: 'category', data: self.todayOrder.map(item => item.CPTDate) },
										self.CPTchartOption.xAxis = { type: 'value', boundaryGap: [0, 0.01] },
										self.CPTChartInstance.setOption(self.CPTchartOption);
								}
							},
							myTool4: {
								show: true,
								title: 'Future Order',
								icon: 'M5.055 7.06C3.805 6.347 2.25 7.25 2.25 8.69v8.122c0 1.44 1.555 2.343 2.805 1.628L12 14.471v2.34c0 1.44 1.555 2.343 2.805 1.628l7.108-4.061c1.26-.72 1.26-2.536 0-3.256l-7.108-4.061C13.555 6.346 12 7.249 12 8.689v2.34L5.055 7.061Z',
								onclick: function () {
									// alert('myToolHandler1')
									console.log('future order', self.futureOrder);
									self.CPTchartOption.series = [
										{ barMinHeight: 25, name: 'Orders', type: 'bar', stack: 'total', data: self.futureOrder.map(item => item.OrdersCount) },
										{ barMinHeight: 25, name: 'Invoices', type: 'bar', stack: 'total', data: self.futureOrder.map(item => item.InvoiceCount) },
										{ barMinHeight: 25, name: 'Cancel Invoice', type: 'bar', stack: 'total', data: self.futureOrder.map(item => item.CancelCount) },
										{ barMinHeight: 25, name: 'Not Invoice', type: 'bar', stack: 'total', data: self.futureOrder.map(item => item.NotInvoice) },
										{ barMinHeight: 25, name: 'Failed', type: 'bar', stack: 'total', data: self.futureOrder.map(item => item.FailedCount) },
										{ barMinHeight: 25, name: 'Picked', type: 'bar', stack: 'total', data: self.futureOrder.map(item => item.PickedCount) },
										{ barMinHeight: 25, name: 'Not Pick', type: 'bar', stack: 'total', data: self.futureOrder.map(item => item.PendingPicked) },
										
									];
									self.CPTchartOption.yAxis = { type: 'category', data: self.futureOrder.map(item => item.CPTDate) },
										self.CPTchartOption.xAxis = { type: 'value', boundaryGap: [0, 0.01] },
										self.CPTChartInstance.setOption(self.CPTchartOption);
								}
							},
							/* myTool1: {
								show: true,
								title: 'All Records',
								icon: 'M960 0v112.941c467.125 0 847.059 379.934 847.059 847.059 0 467.125-379.934 847.059-847.059 847.059-467.125 0-847.059-379.934-847.059-847.059 0-267.106 126.607-515.915 338.824-675.727v393.374h112.94V112.941H0v112.941h342.89C127.058 407.38 0 674.711 0 960c0 529.355 430.645 960 960 960s960-430.645 960-960S1489.355 0 960 0',
								onclick: function () {
									console.log('all order', self.demoChartData);
									self.CPTchartOption.series = [
										{ barMinHeight: 25, name: 'Orders', type: 'bar', stack: 'total', data: self.demoChartData.map(item => item.OrdersCount) },
										{ barMinHeight: 25, name: 'Invoices', type: 'bar', stack: 'total', data: self.demoChartData.map(item => item.InvoiceCount) },
										{ barMinHeight: 25, name: 'Picked', type: 'bar', stack: 'total', data: self.demoChartData.map(item => item.PickedCount) },
										{ barMinHeight: 25, name: 'Not Pick', type: 'bar', stack: 'total', data: self.demoChartData.map(item => item.PendingPicked) },
										{ barMinHeight: 25, name: 'Failed', type: 'bar', stack: 'total', data: self.demoChartData.map(item => item.FailedCount) },
									];
									self.CPTchartOption.yAxis = { type: 'category', data: self.demoChartData.map(item => item.CPTDate) },
										self.CPTchartOption.xAxis = { type: 'value', boundaryGap: [0, 0.01] },
										self.CPTChartInstance.setOption(self.CPTchartOption);
								}
							}, */
						}
					},
					color: ['#1565c0', '#e29578', '#d81111', '#78b101', '#f07897', '#20c997', '#fdbb2d'],
					// series: [
					// 	{ barMinHeight: 25, name: 'Orders', type: 'bar', stack: 'total', data: this.demoChartData.map(item => item.OrdersCount) },
					// 	{ barMinHeight: 25, name: 'Invoices', type: 'bar', stack: 'total', data: this.demoChartData.map(item => item.InvoiceCount) },
					// 	{ barMinHeight: 25, name: 'Picked', type: 'bar', stack: 'total', data: this.demoChartData.map(item => item.PickedCount) },
					// 	{ barMinHeight: 25, name: 'Not Pick', type: 'bar', stack: 'total', data: this.demoChartData.map(item => item.PendingPicked) },
					// 	{ barMinHeight: 25, name: 'Failed', type: 'bar', stack: 'total', data: this.demoChartData.map(item => item.FailedCount) },
					// ],
          			series: [
						{ barMinHeight: 25, name: 'Orders', type: 'bar', stack: 'total', data: this.todayOrder.map(item => item.OrdersCount) },
						{ barMinHeight: 25, name: 'Invoices', type: 'bar', stack: 'total', data: this.todayOrder.map(item => item.InvoiceCount) },
						{ barMinHeight: 25, name: 'Cancel Invoice', type: 'bar', stack: 'total', data: this.todayOrder.map(item => item.CancelCount) },
						{ barMinHeight: 25, name: 'Not Invoice', type: 'bar', stack: 'total', data: this.todayOrder.map(item => item.NotInvoice) },
						{ barMinHeight: 25, name: 'Failed', type: 'bar', stack: 'total', data: this.todayOrder.map(item => item.FailedCount) },
						{ barMinHeight: 25, name: 'Picked', type: 'bar', stack: 'total', data: this.todayOrder.map(item => item.PickedCount) },
						{ barMinHeight: 25, name: 'Not Pick', type: 'bar', stack: 'total', data: this.todayOrder.map(item => item.PendingPicked) },
						
					],
          
				};

				this.CPTChartInstance.hideLoading();
        		self.CPTChartInstance.on('click', function (params) {
					console.log(params);
					if (params.componentType === 'series') {
						console.log('ngZon3:', self.ngZone);
						setTimeout(() => {
						self.ngZone.run(() => {
							self.clickCPTDetails(params.name);
							// self.openStockRatio();
							});
						}, 10);
					}
				}.bind(this));
			});
	}

	orderVsSalesChartOption: EChartOption = {};
	orderVsSalesChartInstance: any;
	orderVsSalesChartData: any[] = [];
	onInitOverVsInvoice($event) {
		this.orderVsSalesChartInstance = $event;
		this.orderVsSalesChartInstance.showLoading();
		let data1 = {
			data: this.EDInvoiceDataForERP,
			Unit_ID: this.unitInfo.Unit_ID,
			Company_ID: this.unitInfo.Company_ID,
			FromDate: moment(this.selecteFromDate).format('YYYY-MM-DD'),
			ToDate: moment(this.selecteToDate).format('YYYY-MM-DD'),
		};
		this.http.post('/api/warehouses/Get_Order_Tracker_Dashboard_Stats_OrderVsSales', data1)
			.subscribe((response: any) => {
				this.orderVsSalesChartData = response;
				this.invoiceRatoData = response;
				let totalInvoiceCount = this.invoiceRatoData.reduce((sum, item) => sum + parseInt(item.InvoiceCount),0);
				  
				  // Add InvoiceRatio to each object
				this.invoiceRatoData.forEach((item) => {
				item.InvoiceRatio = ((parseInt(item.InvoiceCount) / totalInvoiceCount) * 100).toFixed(2);
				});

				// console.log('Order Vs Invoice', this.orderVsSalesChartData);
				this.orderVsSalesChartOption = {
					title: { text: 'Order Vs Invoice', subtext: 'Total Orders and Invoices', show: false },
					tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
					legend: { data: ['Orders', 'Invoices'], type: 'scroll', top: 10 },
					grid: { left: '3%', bottom: '3%', containLabel: true },
					yAxis: { type: 'category', data: this.orderVsSalesChartData.map(item => moment(item.OrderDate).format('DD-MMM')) },
					xAxis: { type: 'value' },
					animationDuration: 500,
					series: [
						{ label: { show: true, position: 'right' }, name: 'Orders', type: 'bar', data: this.orderVsSalesChartData.map(item => item.OrderCount) },
						{ label: { show: true, position: 'right' }, name: 'Invoices', type: 'bar', data: this.orderVsSalesChartData.map(item => item.InvoiceCount) },
					],
				};

				this.invoiceRationOption = {
					grid: {
						top: 0,
						left: 0,
						right: 0,
						containgLabel: false
					},
					tooltip: { trigger: 'item', formatter: '{a} <br/>{b} : {c} ({d}%)' },
					legend: {
						// bottom: '5%',
						type: 'scroll',
						orient: 'horizontal',
						bottom: 10,
					},
					series: [
						{
							name: 'Invoice Ratio',
							type: 'pie',
							radius: ['10', '100'],
							center: ['50%', '50%'],
							// roseType: 'radius',
							avoidLabelOverlap: true,
							padAngle: 25,
							itemStyle: {
								borderRadius: 20
							},
							label: {
								show: true,
								// position: 'inside', 

								formatter: '{d}%'
							},
							data: this.invoiceRatoData.map(item => ({ name: moment(item.OrderDate).format('DD-MMM'), value: item.InvoiceRatio })),
							emphasis: { itemStyle: { shadowBlur: 10, shadowOffsetX: 0, shadowColor: 'rgba(0, 0, 0, 0.5)' } },
						},
					],
				};
			});
		this.orderVsSalesChartInstance.hideLoading();
	}

	invoiceRationOption: EChartOption = {};
	invoiceRationInstance: any;
	invoiceRatoData: any[] = [];
	onInitInvoiceRationChart($event) {
		this.invoiceRationInstance = $event;
		this.invoiceRationInstance.showLoading();
		// create Pie chart for this Invoice ratio
		this.invoiceRationOption = {
			title: { text: 'Invoice Ratio', subtext: 'Total Invoices', show: false },
			tooltip: { trigger: 'item', formatter: '{a} <br/>{b} : {c} ({d}%)' },
			legend: { orient: 'vertical', left: 'left', data: ['Orders', 'Invoices'] },
			series: [
				{
					name: 'Invoice Ratio',
					type: 'pie',
					radius: '55%',
					center: ['50%', '50%'],
					data: this.invoiceRatoData.map(item => ({ name: moment(item.OrderDate).format('DD-MMM'), value: item.Ratio })),
					emphasis: { itemStyle: { shadowBlur: 10, shadowOffsetX: 0, shadowColor: 'rgba(0, 0, 0, 0.5)' } },
				},
			],

		};
		this.invoiceRationInstance.hideLoading();
	}

	sortExcessRationOption: EChartOption = {};
	sortExcessRationInstance: any;
	sortExcessRationData: any[] = [];
	sortExcessRationDetails: any[] = [];
	
	onInitSortExcessRationChart($event) {
		this.sortExcessRationInstance = $event;
		this.sortExcessRationInstance.showLoading();
		let data1 = {
			// data: this.EDInvoiceDataForERP,
			Unit_ID: this.unitInfo.Unit_ID,
			Company_ID: this.unitInfo.Company_ID,
			FromDate: moment(this.selecteFromDate).format('YYYY-MM-DD'),
			ToDate: moment(this.selecteToDate).format('YYYY-MM-DD'),
			VeryFastInventoryDays: this.f_check_number(this.VeryFastInventoryDays),
			FastInventoryDays: this.f_check_number(this.FastInventoryDays),
			MediumInventoryDays: this.f_check_number(this.MediumInventoryDays),
			SlowInventoryDays: this.f_check_number(this.SlowInventoryDays),

		};
		this.http.post('/api/warehouses/Get_Order_Tracker_Dashboard_Stats_ShortExcessStockRatio', data1)
			.subscribe((OTDsresponse: {
				Total_Counts: any[]
				Counts_Details: any[]

			}) => {
				let self = this;
				this.sortExcessRationData = OTDsresponse.Total_Counts;
				this.sortExcessRationDetails = OTDsresponse.Counts_Details;
				this.ShortExcessStockRatio = OTDsresponse.Total_Counts;
				this.ShortExcessStockRatioDetails = OTDsresponse.Counts_Details;
				
				this.sortExcessRationOption = {
					title: { text: 'Short Excess Stock Ratio', subtext: 'Total Short Excess Stock Ratio', show: false },
					tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
					legend: { data: ['Short Ratio', 'Excess Ratio'], type: 'scroll', top: 10  },
					// grid: {  containLabel: false, top: 10 },
					grid: { left: '3%', bottom: '3%', containLabel: true },
					xAxis: { type: 'category', data: this.sortExcessRationData.map(item => item.Slab) },
					yAxis: { type: 'value' },
					animationDuration: 500,
					series: [
						{  barMinHeight: 25, label: { show: true, position: 'top' }, name: 'Short Ratio', type: 'bar', data: this.sortExcessRationData.map(item => item.ShortRatio), },
						{  barMinHeight: 25, label: { show: true, position: 'top' }, name: 'Excess Ratio', type: 'bar', data: this.sortExcessRationData.map(item => item.ExcessRatio),  },
					],
				};
				this.sortExcessRationInstance.hideLoading();
					self.sortExcessRationInstance.on('click', function (params) {
						console.log(params);
						if (params.componentType === 'series') {
							console.log('ngZon3:', self.ngZone);
							setTimeout(() => {
								self.ngZone.run(() => {
									self.clickStockRatio(params.name);
									// self.openStockRatio();
								});
							}, 10);
						}
				}.bind(this));
			});
	}

  GetInvoiceFilterData(type){
    var self = this;
    if(self.f_chkString(type) === 'C'){
      this.GroupData = this.GroupDataFilter.filter(function (item) {
        return self.f_chknum(item.Invoice_Amount) === 0
      });
    }else{
		this.GroupData = this.GroupDataFilter.filter(function (item) {
			return self.f_chknum(item.Invoice_Amount) != 0
		  });
    }
  }

  OkDataExportClicked() {
		console.log("Wellcome to Export");
		let d = new Date();
		var fName = (this.ActiveLable === "Invoice / Cancelled" ? (this.Invoice_Filter_Type === 'C' ? 'Cancelled Invoice' : 'Invoice') : this.ActiveLable);
		var params = {
			columnGroups: true,
			skipFooters: false,
			allColumns: true,
			// customFooter: this.ledgerfooterData1,
			fileName: fName,
		};
		this.gridApiLedgerEntries.exportDataAsCsv(params);
	} 
  
  ExportCPTDetails() {
		console.log("Wellcome to Export");
		let d = new Date();
		var fName = 'CPT Dtails For '+ this.CPTTimeforlable;
		var params = {
			columnGroups: true,
			skipFooters: false,
			allColumns: true,
			// customFooter: this.ledgerfooterData1,
			fileName: fName,
		};
		this.gridApiCPT.exportDataAsCsv(params);
	}

  	public gridApiCPT: any;
	public gridColumnApiCPT: ColumnApi;
	onGridReadyCPT(params) {
		this.gridApiCPT = params.api;
		this.gridColumnApiCPT = params.columnApi;
	}

	CPTTimeforlable: any;
	CPTDetailData: any = [];
	CPTDetailDataForFilter: any = [];
	CPTDataColumnDef: any = [];
	respcpt: any = [];
	clickCPTDetails(x) {
		var self = this;
		console.log("Click on CPT Bar::", x);
		this.CPTTimeforlable = x;
		let data1 = {
			Unit_ID: this.unitInfo.Unit_ID,
			Company_ID: this.unitInfo.Company_ID,
			FromDate: moment(this.selecteFromDate).format('YYYY-MM-DD'),
			ToDate: moment(this.selecteToDate).format('YYYY-MM-DD'),
			CPTDate: x,
		};
		this.busy = this.http.post('/api/warehouses/Get_Order_Tracker_Dashboard_Stats_CPT_Details', data1)
		.subscribe((CPTDTA: any = Array()) => {
			this.respcpt = CPTDTA;
			this.CPTDetailData = [];
			this.CPTDetailData = this.respcpt;
			this.CPTDetailDataForFilter = this.respcpt;
			this.CPTDataColumnDef = [];

			CPTDTA.forEach((element, index) => {
				if (index == 0) {
					Object.keys(element).forEach((key) => {
						self.CPTDataColumnDef.push({
							headerName: key,
							field: key,
						});
					});
				}
			});
			
			setTimeout(() => {
			this.openCPTDataCall();
			}, 300);
		});
	}

  
	openCPTDataCall(): void {
		this.CPT_Filter_Type = 'Orders';
		this.CPTDetailsReference = this.modalService.open(this.CPTDetails, { size: 'sm', windowClass: 'data-show _rightmodal fade Ordertracker visit1', backdropClass: 'top96' });
		// this.FilterData();
		var self = this;

		setTimeout(() => {
			this.gridColumnApiCPT.getAllColumns().forEach(function(column) {
				self.gridColumnApiCPT.autoSizeColumn(column);
			});
			
			let OrdesType = this.findUnique(this.CPTDetailData, d => d.OrderNo);
			var TotalRowData = { "OrderNo": 'Total Order: ' ,"OrderDate": OrdesType.length,  "ProductCode": "Total Product", "Product": this.CPTDetailData.length};
			setTimeout(() => {
				this.gridApiCPT.setPinnedBottomRowData([TotalRowData]);
			}, 300);
		
		this.searchAT = '';
			$('#search_CPT').focus();
		}, 1000);
		
		this.CPTDetailsReference.result.then((result) => {
			console.log('result', result);
		}, (reason) => {
			console.log('reason', reason);
		});
	}

	search_CPT:any;
	onSerachBoxFilterChangedsearch_CPT() {
			let value = $('input#search_CPT').val();
			this.gridApiCPT.setQuickFilter(value);
	};

	DashboardTypeChange(e){
		// console.log("======DashboardTypeChange=================================================>", e);
		this.DashnosrdType = e;
		this.activeWarehouse = 0;
		this.GetOrderTrackerDashboardData();
	}

	FilterData(CPT_Filter_Type){
		var self = this;
		this.CPTDetailData = [];
		if(CPT_Filter_Type === 'Orders'){
			this.CPTDetailData = this.respcpt;
		}else if(CPT_Filter_Type === 'Invoices'){

			this.CPTDetailData = this.CPTDetailDataForFilter.filter(picker => (self.f_check_string(picker.OrderStatus) === self.f_check_string('Picked') || self.f_check_string(picker.OrderStatus) === this.f_check_string('Not Pick')) && self.f_chknum(picker.Is_Cancel_Order) == 0);

		}else if(CPT_Filter_Type === 'CancelledInvoice'){

			this.CPTDetailData = this.CPTDetailDataForFilter.filter(picker => self.f_chknum(picker.Is_Cancel_Order) == 1);

		}else if(CPT_Filter_Type === 'FailedOdrer'){

			this.CPTDetailData = this.CPTDetailDataForFilter.filter(picker => self.f_check_string(picker.OrderStatus) === self.f_check_string('Failed'));

		}else if(CPT_Filter_Type === 'PendingInvoice'){

			this.CPTDetailData = this.CPTDetailDataForFilter.filter(picker => self.f_check_string(picker.OrderStatus) === self.f_check_string('Not Invoice'));

		}else if(CPT_Filter_Type === 'Picked'){

			this.CPTDetailData = this.CPTDetailDataForFilter.filter(picker => self.f_check_string(picker.OrderStatus) === self.f_check_string('Picked'));

		}else if(CPT_Filter_Type === 'NotPick'){

			this.CPTDetailData = this.CPTDetailDataForFilter.filter(picker => self.f_check_string(picker.OrderStatus) === self.f_check_string('Not Pick'));

		}else{
			this.CPTDetailData = this.respcpt;
		}
		
		let OrdesType = this.findUnique(this.CPTDetailData, d => d.OrderNo);
		var TotalRowData = { "OrderNo": 'Total Order: ' ,"OrderDate": OrdesType.length,  "ProductCode": "Total Product", "Product": this.CPTDetailData.length};
		setTimeout(() => {
			this.gridApiCPT.setPinnedBottomRowData([TotalRowData]);
			self.gridColumnApiCPT.autoSizeAllColumns();
		}, 300);
	}

	findUnique(arr, predicate) {
		var found = {};
		arr.forEach(d => {
			found[predicate(d)] = d;
		});
		return Object.keys(found).map(key => found[key]);
	}

	respDOHStockList:any = [];
	DOHStockList:any = [];
	public gridApiDOHStockAPI: any;
	public gridColumnApiDOHStockAPI: any = [];

	onGridReadyDOHStockAPI(params) {
		this.gridApiDOHStockAPI = params.api;
		this.gridColumnApiDOHStockAPI = params.columnApi;
	}

	GetDOHStock(){
		var self = this;
		let data1 = {
			Unit_ID: this.unitInfo.Unit_ID,
			Company_ID: this.unitInfo.Company_ID,
			FromDate: moment(this.selecteFromDate).format('YYYY-MM-DD'),
			ToDate: moment(this.selecteToDate).format('YYYY-MM-DD'),
		};
		this.busy = this.http.post('/api/warehouses/Get_Order_Tracker_Dashboard_Stats_DOHStock', data1)
		.subscribe((response: any) => {
			this.respDOHStockList = response;
				this.DOHStockList = [];
				this.DOHStockList = this.respDOHStockList;
				// this.DOHStockListFilter = this.respDOHStockList;
				this.gridColumnApiDOHStockAPI = [];
				// create column defination using api response
				response.forEach((element, index) => {
					if (index == 0) {
						Object.keys(element).forEach((key) => {
							self.gridColumnApiDOHStockAPI.push({
								headerName: key,
								field: key,
							});
						});
					}
				});
				setTimeout(() => {
					console.log('===================================================>',this.gridColumnApiDOHStockAPI);
					this.OpenDOHStockAPIPopUp();
				}, 500);
		});
	}

	OpenDOHStockAPIPopUp(){
		var self = this;
 		this.DOHStockReference = this.modalService.open(this.DOHStock, { size: 'sm', windowClass: 'data-show _rightmodal fade Ordertracker visit1', backdropClass: 'top96' });

		setTimeout(() => {
			this.gridColumnApiDOHStockAPI.getAllColumns().forEach(function(column) {
				self.gridColumnApiDOHStockAPI.autoSizeColumn(column);
			});
		}, 200);
		this.DOHStockReference.result.then((result) => {
			console.log('result', result);
		}, (reason) => {
			console.log('reason', reason);
		});
	}

	OkClickedDOH() {
		console.log("Wellcome to Export");
		let d = new Date();
		var fName = 'DOH Stock Details' + this.SortType;
		var params = {
			columnGroups: true,
			skipFooters: false,
			allColumns: true,
			// customFooter: this.ledgerfooterData1,
			fileName: fName,
		};
		this.gridApiDOHStockAPI.exportDataAsCsv(params);
	}
}



/* function timeParse(arg0: string) {
  throw new Error('Function not implemented.');
} */
